const data = [
  {
    song_id: 30183424,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CB7qF7f63Hnv6vNKISLl6hkW2M8cfSbUo65w/D09OOw=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10028121.jpg",
    title: "너에게 닿기를 (I Wish)",
    duration: 218,
    artist_id: "943959",
    artist_name: "우주소녀",
  },
  {
    song_id: 5681153,
    music:
      "https://api1.indj.club/api/v3/music/file?code=x5D4xRHHGZrzA9G4r03GKWbWMQ56FDdyqXLGeLsCPVg=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2316261.jpg",
    title: "I NEED U",
    duration: 210,
    artist_id: "672375",
    artist_name: "BTS",
  },
  {
    song_id: 7870472,
    music:
      "https://api1.indj.club/api/v3/music/file?code=sYARyn3L4ZFa5ZUF4dwcV+Ss65E5VG5yjuBKiZoaVfI=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2639766.jpg",
    title: "Ah-Choo",
    duration: 218,
    artist_id: "789331",
    artist_name: "러블리즈",
  },
  {
    song_id: 31006730,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CVr7iViaq8BtvPAgJ4G+8znsf+nYdjwLJKxt7ei7Zc0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10156195.jpg",
    title: "What is Love?",
    duration: 208,
    artist_id: "905701",
    artist_name: "TWICE (트와이스)",
  },
  {
    song_id: 31025164,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CVr7iViaq8BtvPAgJ4G+8+fIIJzJJw6bn/FBwJJlLS0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10159006.jpg",
    title: "EASY (Feat. 식케이)",
    duration: 189,
    artist_id: "756533",
    artist_name: "휘인 (Whee In)",
  },
  {
    song_id: 33589260,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ryL1U6WxMKWNQ4qgdOZ64tt2xs++4/O/1l07u5mX3oA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10631055.jpg",
    title: "치맛바람 (Chi Mat Ba Ram)",
    duration: 217,
    artist_id: "531700",
    artist_name: "브레이브걸스",
  },
  {
    song_id: 30205969,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CB7qF7f63Hnv6vNKISLl6njYDyobWgp4DOGT9NItTUw=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10031746.jpg",
    title: "Don't Say No",
    duration: 193,
    artist_id: "401220",
    artist_name: "서현 (SEOHYUN)",
  },
  {
    song_id: 32725017,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ooM76PGk2EhCbg9XsmVqE7jjjgvuRaxSxMIKISdGlSA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10452351.jpg",
    title: "LMM",
    duration: 282,
    artist_id: "756531",
    artist_name: "화사 (Hwa Sa)",
  },
  {
    song_id: 32489498,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ooM76PGk2EhCbg9XsmVqE2BWRhkBOH6fvZy6i+02LBk=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10408680.jpg",
    title: "High",
    duration: 178,
    artist_id: "765084",
    artist_name: "5 Seconds of Summer",
  },
  {
    song_id: 32725022,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ooM76PGk2EhCbg9XsmVqE872vF5LfOTyi/VBo0xr7hg=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10452354.jpg",
    title: "보라빛 밤 (pporappippam)",
    duration: 207,
    artist_id: "22938",
    artist_name: "선미",
  },
  {
    song_id: 35737633,
    music:
      "https://api1.indj.club/api/v3/music/file?code=5aZlvb6vnqARv0AXAW85c3EiVQnPydZ9TRE8rbFDORk=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11080694.jpg",
    title: "Boys Like You",
    duration: 224,
    artist_id: "2622030",
    artist_name: "ITZY (있지)",
  },
  {
    song_id: 5738546,
    music:
      "https://api1.indj.club/api/v3/music/file?code=EnfEiVdDZ4lr7H9mSjJbssve7ofGRTu66ebIwF5VMok=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2323974.jpg",
    title: "우리집",
    duration: 188,
    artist_id: "259822",
    artist_name: "2PM",
  },
  {
    song_id: 8042553,
    music:
      "https://api1.indj.club/api/v3/music/file?code=F2N/5juEwMqskrXKGvjGcDrfkPmhEgV49BtJV9kShfk=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2665523.jpg",
    title: "Rain",
    duration: 222,
    artist_id: "236797",
    artist_name: "TAEYEON (태연)",
  },
  {
    song_id: 36491330,
    music:
      "https://api1.indj.club/api/v3/music/file?code=gg/xYemUVYvbQtSeGA334HC314H1ANcFX+0AH5unqtQ=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11255043.jpg",
    title: "Die for love (feat. Jessi)",
    duration: 199,
    artist_id: "742760",
    artist_name: "B.I",
  },
  {
    song_id: 31848518,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CVr7iViaq8BtvPAgJ4G+83gY94TzOxYE+T33jJsgPGU=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10293846.jpg",
    title: "Boogie Up",
    duration: 184,
    artist_id: "943959",
    artist_name: "우주소녀",
  },
  {
    song_id: 34668619,
    music:
      "https://api1.indj.club/api/v3/music/file?code=XH032bAa5tKJmHTeUeydFmWq9nrOvS5RWW9VOdi+0Qo=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10873811.jpg",
    title: "RUN2U",
    duration: 214,
    artist_id: "2899290",
    artist_name: "STAYC(스테이씨)",
  },
  {
    song_id: 32079958,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ooM76PGk2EhCbg9XsmVqEygqsvD7BUNmFpaBiJ71xhM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10335460.jpg",
    title: "Jopping",
    duration: 251,
    artist_id: "2744752",
    artist_name: "SuperM",
  },
  {
    song_id: 33456218,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ryL1U6WxMKWNQ4qgdOZ64ilLLz6usUrRFn/mQJkgroE=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10602760.jpg",
    title: "맛 (Hot Sauce)",
    duration: 196,
    artist_id: "1066419",
    artist_name: "NCT DREAM",
  },
  {
    song_id: 8247388,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FOBey3I/FKROr5/srR2qBqKU4Q8ZwOxA+8GQ3s10mvo=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2694420.jpg",
    title: "넘나 좋은 것 (I Like U Too Much)",
    duration: 205,
    artist_id: "792822",
    artist_name: "소나무 (SONAMOO)",
  },
  {
    song_id: 31189085,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CVr7iViaq8BtvPAgJ4G+87DHUTKNnObcoVRTdiimv3c=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10185387.jpg",
    title: "어쩌나",
    duration: 195,
    artist_id: "861436",
    artist_name: "세븐틴",
  },
  {
    song_id: 30824542,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CB7qF7f63Hnv6vNKISLl6t+8nFM4GQOIhxIgTqS67ps=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10126355.jpg",
    title: "Shall We Dance",
    duration: 181,
    artist_id: "532201",
    artist_name: "블락비 (Block B)",
  },
  {
    song_id: 31115358,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CVr7iViaq8BtvPAgJ4G+8/ID+OK0xd8kf47rIDzwrpM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10173711.jpg",
    title: "숙녀 (淑女)",
    duration: 196,
    artist_id: "673291",
    artist_name: "유빈",
  },
  {
    song_id: 34682972,
    music:
      "https://api1.indj.club/api/v3/music/file?code=XH032bAa5tKJmHTeUeydFtCAO2libZ0xcYNCNT7JbXU=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10877261.jpg",
    title: "GingaMingaYo (the strange world)",
    duration: 216,
    artist_id: "3048993",
    artist_name: "Billlie",
  },
  {
    song_id: 32458855,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ooM76PGk2EhCbg9XsmVqE3ka11+Pbla8ywI+JcEAetE=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10402727.jpg",
    title: "To Die For (Acoustic)",
    duration: 201,
    artist_id: "718042",
    artist_name: "Sam Smith",
  },
  {
    song_id: 3663978,
    music:
      "https://api1.indj.club/api/v3/music/file?code=gg/xYemUVYvbQtSeGA334G0FmT15uA843RY/btPoTGU=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2058067.jpg",
    title: "Lovey-Dovey",
    duration: 215,
    artist_id: "412000",
    artist_name: "티아라",
  },
  {
    song_id: 2748528,
    music:
      "https://api1.indj.club/api/v3/music/file?code=/68EBKltK0B/T6y2VXJPZW7wj2lMaBMEhED39ZkKmxA=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/944653.jpg",
    title: "queen",
    duration: 196,
    artist_id: "226582",
    artist_name: "손담비",
  },
  {
    song_id: 8204402,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FOBey3I/FKROr5/srR2qBkL+nr71TY4BcaRTLwAPR5c=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2688030.jpg",
    title: "Free Somebody",
    duration: 200,
    artist_id: "498356",
    artist_name: "루나 (LUNA)",
  },
  {
    song_id: 34168947,
    music:
      "https://api1.indj.club/api/v3/music/file?code=XH032bAa5tKJmHTeUeydFmeDJtjSKkoFlP2CLpfVnvs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10753894.jpg",
    title: "가르치지마",
    duration: 195,
    artist_id: "629831",
    artist_name: "에일리(AILEE)",
  },
  {
    song_id: 33749109,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ryL1U6WxMKWNQ4qgdOZ64t5+lfzz3Eb1hfj3sRlMbHg=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10667450.jpg",
    title: "DUMB DUMB",
    duration: 0,
    artist_id: "968260",
    artist_name: "전소미",
  },
  {
    song_id: 35762296,
    music:
      "https://api1.indj.club/api/v3/music/file?code=5aZlvb6vnqARv0AXAW85c8Jg51vXWOt/9W+FVxoT0ks=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11086158.jpg",
    title: "Tick Tick Boom",
    duration: 180,
    artist_id: "3092045",
    artist_name: "CLASS:y (클라씨)",
  },
  {
    song_id: 31230093,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CVr7iViaq8BtvPAgJ4G+8+6+EvDkDf1FvHTZQo5qBsM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10191694.jpg",
    title: "Power Up",
    duration: 202,
    artist_id: "780066",
    artist_name: "Red Velvet (레드벨벳)",
  },
  {
    song_id: 36599950,
    music:
      "https://api1.indj.club/api/v3/music/file?code=gg/xYemUVYvbQtSeGA334F533eVvxKs7z0Q47ooYm/M=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11281456.jpg",
    title: "Super Shy",
    duration: 155,
    artist_id: "3114174",
    artist_name: "NewJeans",
  },
  {
    song_id: 32620700,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ooM76PGk2EhCbg9XsmVqE2PnTpn+kdBNCEvkj+6aAzY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10434955.jpg",
    title: "Candy",
    duration: 227,
    artist_id: "672859",
    artist_name: "백현 (BAEKHYUN)",
  },
  {
    song_id: 32465057,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ooM76PGk2EhCbg9XsmVqE1RUNbe4U5AEifWAWunu1Lw=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10404130.jpg",
    title: "Hellevator",
    duration: 240,
    artist_id: "2006344",
    artist_name: "Stray Kids (스트레이 키즈)",
  },
  {
    song_id: 32889003,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ooM76PGk2EhCbg9XsmVqE+xFVGV/CnB0soG2PtwD2js=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10482568.jpg",
    title: "Ice Cream (with Selena Gomez)",
    duration: 176,
    artist_id: "995169",
    artist_name: "BLACKPINK",
  },
  {
    song_id: 4221101,
    music:
      "https://api1.indj.club/api/v3/music/file?code=vlw17IZKnnMOy+e6EevaNaEY5eYO/1LhuUdHdow7hig=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2198608.jpg",
    title: "Tonight",
    duration: 219,
    artist_id: "615471",
    artist_name: "스피카",
  },
  {
    song_id: 33999025,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ryL1U6WxMKWNQ4qgdOZ64tSKQPPlrPhuTnAt3LvSWXc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10721169.jpg",
    title: "LOCO",
    duration: 192,
    artist_id: "2622030",
    artist_name: "ITZY (있지)",
  },
  {
    song_id: 32907450,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ooM76PGk2EhCbg9XsmVqE8CAwpum7nbZd3ESSDLdrpA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10486462.jpg",
    title: "숲의 아이 (Bon voyage)",
    duration: 220,
    artist_id: "858000",
    artist_name: "유아 (오마이걸)",
  },
  {
    song_id: 32313543,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ooM76PGk2EhCbg9XsmVqE0+IzrXIz70dQCwPsVmTsGA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10375118.jpg",
    title: "아무노래",
    duration: 227,
    artist_id: "602056",
    artist_name: "지코 (ZICO)",
  },
  {
    song_id: 31133897,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CVr7iViaq8BtvPAgJ4G+886ChfAiMKamThS0b3FRyF4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10175106.jpg",
    title: "Call me",
    duration: 212,
    artist_id: "647971",
    artist_name: "비투비",
  },
  {
    song_id: 33104090,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ryL1U6WxMKWNQ4qgdOZ64iOnQAZbItVtVD7K0tKafPs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10527241.jpg",
    title: "혼술하고 싶은 밤",
    duration: 216,
    artist_id: "655051",
    artist_name: "벤",
  },
  {
    song_id: 33405149,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ryL1U6WxMKWNQ4qgdOZ64s0Xc1Ci76DgZyy/x8PASZo=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10590812.jpg",
    title: "그냥 안아달란 말야",
    duration: 203,
    artist_id: "236815",
    artist_name: "다비치",
  },
  {
    song_id: 3911902,
    music:
      "https://api1.indj.club/api/v3/music/file?code=jwtVzeUnmwknZCdUzgsjdEiYSTVpi3LYEBfVS1QiZb8=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2150991.jpg",
    title: "STYLE",
    duration: 202,
    artist_id: "532321",
    artist_name: "라니아",
  },
  {
    song_id: 30720227,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CB7qF7f63Hnv6vNKISLl6kTTT9YP1r79/btEFMPUXeA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10110239.jpg",
    title: "나를 기억해",
    duration: 202,
    artist_id: "1066850",
    artist_name: "VICTON (빅톤)",
  },
  {
    song_id: 3928294,
    music:
      "https://api1.indj.club/api/v3/music/file?code=jwtVzeUnmwknZCdUzgsjdF0HefHbRGbRZKr9ta2vpYs=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2153096.jpg",
    title: "남자 없이 잘 살아",
    duration: 211,
    artist_id: "481481",
    artist_name: "미쓰에이",
  },
  {
    song_id: 33970408,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ryL1U6WxMKWNQ4qgdOZ64hphcyQQNzIIn4bZZlx0XAI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10715144.jpg",
    title: "하늘 땅 바다만큼 (mumumumuch)",
    duration: 210,
    artist_id: "750053",
    artist_name: "마마무 (Mamamoo)",
  },
  {
    song_id: 8130796,
    music:
      "https://api1.indj.club/api/v3/music/file?code=KTwfXPoAKIqFPEEw49NypdAoYjvA2n8/i84d26z8cM4=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2677681.jpg",
    title: "상상더하기",
    duration: 243,
    artist_id: "783462",
    artist_name: "라붐 (LABOUM)",
  },
  {
    song_id: 32860397,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ooM76PGk2EhCbg9XsmVqE9v4LOZy5XCukYApqDILDNM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10476623.jpg",
    title: "운전만해 (We Ride)",
    duration: 190,
    artist_id: "531700",
    artist_name: "브레이브걸스",
  },
  {
    song_id: 36014317,
    music:
      "https://api1.indj.club/api/v3/music/file?code=gg/xYemUVYvbQtSeGA334LlE+1x6eGzwbFbstD4FkmA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11141889.jpg",
    title: "Beautiful Liar",
    duration: 184,
    artist_id: "791216",
    artist_name: "몬스타엑스",
  },
  {
    song_id: 7870705,
    music:
      "https://api1.indj.club/api/v3/music/file?code=sYARyn3L4ZFa5ZUF4dwcV+KghatCnd3G183vnDYuBP4=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2640151.jpg",
    title: "리듬 타 (RHYTHM TA)",
    duration: 228,
    artist_id: "895741",
    artist_name: "iKON",
  },
  {
    song_id: 34883833,
    music:
      "https://api1.indj.club/api/v3/music/file?code=XH032bAa5tKJmHTeUeydFvC+ScIkEYihKv5tV9EiBak=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10918269.jpg",
    title: "ZOOM",
    duration: 175,
    artist_id: "176393",
    artist_name: "Jessi (제시)",
  },
  {
    song_id: 35993850,
    music:
      "https://api1.indj.club/api/v3/music/file?code=5aZlvb6vnqARv0AXAW85c77kze0gWVYeAHvP+rp+J/o=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11138555.jpg",
    title: "Stamp On It",
    duration: 233,
    artist_id: "3063272",
    artist_name: "GOT the beat",
  },
  {
    song_id: 5767428,
    music:
      "https://api1.indj.club/api/v3/music/file?code=EnfEiVdDZ4lr7H9mSjJbsjqhxjI39IePV4KUpZdFE2k=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2327866.jpg",
    title: "Darling",
    duration: 194,
    artist_id: "482762",
    artist_name: "걸스데이",
  },
  {
    song_id: 31668491,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CVr7iViaq8BtvPAgJ4G+828EzPLPvAzk3xAzRns/ixE=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10261306.jpg",
    title: "고고베베 (gogobebe)",
    duration: 220,
    artist_id: "750053",
    artist_name: "마마무 (Mamamoo)",
  },
  {
    song_id: 3946768,
    music:
      "https://api1.indj.club/api/v3/music/file?code=jwtVzeUnmwknZCdUzgsjdKTbwPWU8gNBQMNrBCr1K2Y=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2165012.jpg",
    title: "1,2,3,4 (원,투,쓰리,포)",
    duration: 214,
    artist_id: "646171",
    artist_name: "이하이",
  },
  {
    song_id: 32112914,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ooM76PGk2EhCbg9XsmVqE2x5BvrfanhMlMJQaKzFG8Q=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10341654.jpg",
    title: "9와 4분의 3 승강장에서 너를 기다려 (Run Away)",
    duration: 212,
    artist_id: "2632253",
    artist_name: "투모로우바이투게더",
  },
  {
    song_id: 33280282,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ryL1U6WxMKWNQ4qgdOZ64md9SkwByhhvQAsOGCYgmFQ=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10563256.jpg",
    title: "ZERO:ATTITUDE (Feat. pH-1)",
    duration: 181,
    artist_id: "490981,2398653",
    artist_name: "소유 (SOYOU),IZ*ONE (아이즈원)",
  },
  {
    song_id: 35371300,
    music:
      "https://api1.indj.club/api/v3/music/file?code=5aZlvb6vnqARv0AXAW85cyWtoDkckHccj/wO9BqeWMQ=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10997520.jpg",
    title: "I LOVE U",
    duration: 177,
    artist_id: "775197",
    artist_name: "WINNER",
  },
  {
    song_id: 3801396,
    music:
      "https://api1.indj.club/api/v3/music/file?code=yH4jbvteDYU6mbdFAQw8tM6Vzin02Ea3HRR6Dj7KEOE=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2123894.jpg",
    title: "추격자",
    duration: 203,
    artist_id: "476181",
    artist_name: "인피니트",
  },
  {
    song_id: 34769205,
    music:
      "https://api1.indj.club/api/v3/music/file?code=XH032bAa5tKJmHTeUeydFhQRk+P1PicbHL/5zl+lHUI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10893657.jpg",
    title: "MANIAC",
    duration: 182,
    artist_id: "2006344",
    artist_name: "Stray Kids (스트레이 키즈)",
  },
  {
    song_id: 31740215,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CVr7iViaq8BtvPAgJ4G+85ZtMkcpk/MFMk3lwQ3+seY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10274263.jpg",
    title: "처음이라서",
    duration: 258,
    artist_id: "2639564",
    artist_name: "정효빈",
  },
  {
    song_id: 34101563,
    music:
      "https://api1.indj.club/api/v3/music/file?code=XH032bAa5tKJmHTeUeydFmcOyZmMlUKCLGp5Rwp9LHg=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10743453.jpg",
    title: "strawberry moon",
    duration: 205,
    artist_id: "261143",
    artist_name: "IU (아이유)",
  },
  {
    song_id: 30558525,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CB7qF7f63Hnv6vNKISLl6gHjdFPJfd0jFyTneseIhG4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10084442.jpg",
    title: "귀를 기울이면 (LOVE WHISPER)",
    duration: 212,
    artist_id: "828478",
    artist_name: "여자친구 (GFRIEND)",
  },
  {
    song_id: 8038718,
    music:
      "https://api1.indj.club/api/v3/music/file?code=F2N/5juEwMqskrXKGvjGcADWbsy3njD9/AsEl8utBrA=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2664983.jpg",
    title: "싫어 (Hate)",
    duration: 216,
    artist_id: "417985",
    artist_name: "4minute",
  },
  {
    song_id: 33970495,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ryL1U6WxMKWNQ4qgdOZ64ubuzpdOeq3dAIPd5cFPq1g=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10715163.jpg",
    title: "Lover Like Me",
    duration: 178,
    artist_id: "441844",
    artist_name: "CL",
  },
  {
    song_id: 31594816,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZ4V2vJapcMIMs0NJ/xU+w64=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10248296.jpg",
    title: "Purpose (Stripped)",
    duration: 196,
    artist_id: "1907334",
    artist_name: "Etham",
  },
  {
    song_id: 8153410,
    music:
      "https://api1.indj.club/api/v3/music/file?code=8Ecth3YMi/hx/mnvmexB34o6w0+QQ+kJ6ywMKSUD1iM=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2680682.jpg",
    title: "예쁘다",
    duration: 207,
    artist_id: "861436",
    artist_name: "세븐틴",
  },
  {
    song_id: 35711298,
    music:
      "https://api1.indj.club/api/v3/music/file?code=LBvyBmXEGFCFltJH2i7UOHvjyTa0VuPoxQjwPMROd4c=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11074257.jpg",
    title: "We Fresh",
    duration: 196,
    artist_id: "3058246",
    artist_name: "Kep1er (케플러)",
  },
  {
    song_id: 36391236,
    music:
      "https://api1.indj.club/api/v3/music/file?code=OhorDShJBVoSZMiDvS7xhS0Lrt/O6mIaT+iXY9Dc/E8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11229537.jpg",
    title: "손오공",
    duration: 200,
    artist_id: "861436",
    artist_name: "세븐틴",
  },
  {
    song_id: 35238220,
    music:
      "https://api1.indj.club/api/v3/music/file?code=LBvyBmXEGFCFltJH2i7UOMr5iFNfVofMQ46tygm+2lE=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10972706.jpg",
    title: "Girls",
    duration: 241,
    artist_id: "2899555",
    artist_name: "aespa",
  },
  {
    song_id: 35238221,
    music:
      "https://api1.indj.club/api/v3/music/file?code=LBvyBmXEGFCFltJH2i7UOMr5naa8f5WZyiZ1EBlpLFo=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10972706.jpg",
    title: "도깨비불 (Illusion)",
    duration: 196,
    artist_id: "2899555",
    artist_name: "aespa",
  },
  {
    song_id: 31754579,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZ4WaMQmvfK0AigoT6gHsLb8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10276861.jpg",
    title: "FANCY",
    duration: 213,
    artist_id: "905701",
    artist_name: "TWICE (트와이스)",
  },
  {
    song_id: 31754581,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZ5fldEzkiPZYzSLFPHfgTMc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10276861.jpg",
    title: "GIRLS LIKE US",
    duration: 158,
    artist_id: "905701",
    artist_name: "TWICE (트와이스)",
  },
  {
    song_id: 5644636,
    music:
      "https://api1.indj.club/api/v3/music/file?code=V+scQa4hQztIAHVnBsGz2XUAMlpRuIEwZ7tzZDKgadU=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2311419.jpg",
    title: "다른 남자 말고 너",
    duration: 198,
    artist_id: "481481",
    artist_name: "미쓰에이",
  },
  {
    song_id: 33902950,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdc4nYEYRrigJwSQdprvFNMw=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10704178.jpg",
    title: "색안경 (STEREOTYPE)",
    duration: 192,
    artist_id: "2899290",
    artist_name: "STAYC(스테이씨)",
  },
  {
    song_id: 33352039,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdXPCxO9gDAwB9pOGAvc8uss=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10578450.jpg",
    title: "House Party",
    duration: 241,
    artist_id: "175404",
    artist_name: "SUPER JUNIOR (슈퍼주니어)",
  },
  {
    song_id: 35690857,
    music:
      "https://api1.indj.club/api/v3/music/file?code=LBvyBmXEGFCFltJH2i7UOJmuW5YgEUB08sFRGnOdbSM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11069153.jpg",
    title: "HELLO",
    duration: 182,
    artist_id: "2880278",
    artist_name: "TREASURE (트레저)",
  },
  {
    song_id: 32455023,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9F0/l+j0j0SkaEwgsDXcRTRqiGy2w7u0JieIbClgLg8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10401953.jpg",
    title: "Lonely Night",
    duration: 243,
    artist_id: "760046",
    artist_name: "권진아",
  },
  {
    song_id: 35371375,
    music:
      "https://api1.indj.club/api/v3/music/file?code=LBvyBmXEGFCFltJH2i7UOM2IARoH10p7HA+WyeDENJ4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10997548.jpg",
    title: "Last Sequence",
    duration: 188,
    artist_id: "943959",
    artist_name: "우주소녀",
  },
  {
    song_id: 36034936,
    music:
      "https://api1.indj.club/api/v3/music/file?code=OhorDShJBVoSZMiDvS7xhfDvTHXMmsbcjeyK2oam7gI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11146937.jpg",
    title: "VIBE (feat. Jimin of BTS)",
    duration: 176,
    artist_id: "247621",
    artist_name: "태양",
  },
  {
    song_id: 33239419,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdRU8nYoA6i36dTlm4Ojpgbk=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10554246.jpg",
    title: "Celebrity",
    duration: 196,
    artist_id: "261143",
    artist_name: "IU (아이유)",
  },
  {
    song_id: 9640320,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B4QEGD0MH2buC05pIn8VkZ1ZFQ7ExWPUl6xdl8lL1vY=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2710304.jpg",
    title: "Carnival (The Last Day)",
    duration: 262,
    artist_id: "428821",
    artist_name: "가인",
  },
  {
    song_id: 3783041,
    music:
      "https://api1.indj.club/api/v3/music/file?code=BbnPCWHRB3WWNR8vIUyW2u21TVEN6iglOzIOnm5BOwA=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2117429.jpg",
    title: "Twinkle",
    duration: 207,
    artist_id: "663691",
    artist_name: "소녀시대-태티서 (Girls' Generation-TTS)",
  },
  {
    song_id: 35225986,
    music:
      "https://api1.indj.club/api/v3/music/file?code=LBvyBmXEGFCFltJH2i7UOKUiH8/cnX3HY+ZPhyDkevM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10969893.jpg",
    title: "Beatbox",
    duration: 206,
    artist_id: "1066419",
    artist_name: "NCT DREAM",
  },
  {
    song_id: 31951249,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZ2wHlA/OIzlBefTEGmUqor4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10311530.jpg",
    title: "BOOM",
    duration: 195,
    artist_id: "1066419",
    artist_name: "NCT DREAM",
  },
  {
    song_id: 33280406,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdXfehmc4b2hYMqKmsRcEEUw=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10563287.jpg",
    title: "짜증 나게 만들어",
    duration: 203,
    artist_id: "968265",
    artist_name: "청하",
  },
  {
    song_id: 33280407,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdQLksHvKuxaC345ognHmwAY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10563287.jpg",
    title: "Chill해",
    duration: 206,
    artist_id: "968265",
    artist_name: "청하",
  },
  {
    song_id: 33139120,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdQ38BI6lb1lY/KgPnrXngDI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10534079.jpg",
    title: "들불 (Wildfire)",
    duration: 205,
    artist_id: "236797",
    artist_name: "TAEYEON (태연)",
  },
  {
    song_id: 31717823,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZ3PfXteSJo8WFP2dTmXAiYo=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10270288.jpg",
    title: "Don't Know What To Do",
    duration: 201,
    artist_id: "995169",
    artist_name: "BLACKPINK",
  },
  {
    song_id: 32012743,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9F0/l+j0j0SkaEwgsDXcRW+FnFeGA6dbbci1uzFB000=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10322332.jpg",
    title: "FLASH",
    duration: 211,
    artist_id: "2743578",
    artist_name: "X1 (엑스원)",
  },
  {
    song_id: 34140616,
    music:
      "https://api1.indj.club/api/v3/music/file?code=rWOLfpSPOaveP1m1KJ+6kF3evzBX4rqZDHZx4vB6pf8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10749330.jpg",
    title: "Rock with you",
    duration: 0,
    artist_id: "861436",
    artist_name: "세븐틴",
  },
  {
    song_id: 32057802,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9F0/l+j0j0SkaEwgsDXcRRilEz6cZzpXSXw+/VS/CoU=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10331167.jpg",
    title: "Feel Special",
    duration: 206,
    artist_id: "905701",
    artist_name: "TWICE (트와이스)",
  },
  {
    song_id: 30529996,
    music:
      "https://api1.indj.club/api/v3/music/file?code=trYdTAfD4PkNjuNqRiTCuRm69rhntwTBjHQDiJrKfks=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10080589.jpg",
    title: "Ko Ko Bop",
    duration: 190,
    artist_id: "724619",
    artist_name: "EXO",
  },
  {
    song_id: 32559566,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9F0/l+j0j0SkaEwgsDXcRaDCpGl7KWFpnnhvgZyW9uc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10423244.jpg",
    title: "넌 내가 보고 싶지 않나 봐",
    duration: 205,
    artist_id: "2740042",
    artist_name: "신예영",
  },
  {
    song_id: 31336911,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZwZDnzMbN1PaDklG6XTH8UQ=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10209162.jpg",
    title: "빠져가 (Into You)",
    duration: 187,
    artist_id: "428786",
    artist_name: "유리 (YURI)",
  },
  {
    song_id: 33309138,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdWc1lO8S75Bi9tLYIv34NH4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10568886.jpg",
    title: "꼬리 (TAIL)",
    duration: 191,
    artist_id: "22938",
    artist_name: "선미",
  },
  {
    song_id: 31158741,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZ/+HDPi9g0bvC2Q0lBICoik=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10180637.jpg",
    title: "여름 한 조각",
    duration: 211,
    artist_id: "789331",
    artist_name: "러블리즈",
  },
  {
    song_id: 32399830,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9F0/l+j0j0SkaEwgsDXcRSSqV4ij+SAMGBdzf1xZDyU=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10377346.jpg",
    title: "ON",
    duration: 246,
    artist_id: "672375",
    artist_name: "BTS",
  },
  {
    song_id: 33464805,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdaCM+aFhaAr0+I40YC9N5A4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10604729.jpg",
    title: "Dun Dun Dance",
    duration: 221,
    artist_id: "857994",
    artist_name: "오마이걸 (OH MY GIRL)",
  },
  {
    song_id: 33503722,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdUWkeJVBNWETwhjLpfN9US8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10611845.jpg",
    title: "헤픈 우연",
    duration: 194,
    artist_id: "751611",
    artist_name: "헤이즈 (Heize)",
  },
  {
    song_id: 33487342,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdVHW7eA7xclojURkY8fGqTs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10609232.jpg",
    title: "Next Level",
    duration: 222,
    artist_id: "2899555",
    artist_name: "aespa",
  },
  {
    song_id: 34636290,
    music:
      "https://api1.indj.club/api/v3/music/file?code=rWOLfpSPOaveP1m1KJ+6kPD3GHeb2rLJDIhRmRK+uxM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10866447.jpg",
    title: "Dilemma",
    duration: 210,
    artist_id: "534360",
    artist_name: "Apink (에이핑크)",
  },
  {
    song_id: 34904578,
    music:
      "https://api1.indj.club/api/v3/music/file?code=rWOLfpSPOaveP1m1KJ+6kHR3hZP8NyMMYmp7Wo0wCyM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10922231.jpg",
    title: "Darl+ing",
    duration: 176,
    artist_id: "861436",
    artist_name: "세븐틴",
  },
  {
    song_id: 30413328,
    music:
      "https://api1.indj.club/api/v3/music/file?code=trYdTAfD4PkNjuNqRiTCuWkmEsYGrBYzEnJyAdqeJfo=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10062172.jpg",
    title: "ONLY 너",
    duration: 218,
    artist_id: "905701",
    artist_name: "TWICE (트와이스)",
  },
  {
    song_id: 32872978,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9F0/l+j0j0SkaEwgsDXcRcxCsl9eTJKhCVL9ZwHj1H4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10479150.jpg",
    title: "Dynamite",
    duration: 200,
    artist_id: "672375",
    artist_name: "BTS",
  },
  {
    song_id: 32061975,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9F0/l+j0j0SkaEwgsDXcRRVxt5SNf7nTFHkpmfjcc/I=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10331947.jpg",
    title: "어떻게 이별까지 사랑하겠어, 널 사랑하는 거지",
    duration: 290,
    artist_id: "712452",
    artist_name: "AKMU (악동뮤지션)",
  },
  {
    song_id: 31998495,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZ0I5ejjN9GyviyRdCdQrbzY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10319561.jpg",
    title: "음파음파 (Umpah Umpah)",
    duration: 220,
    artist_id: "780066",
    artist_name: "Red Velvet (레드벨벳)",
  },
  {
    song_id: 31996468,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZxU1xk0UDd00Zyr73itEK9U=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10319189.jpg",
    title: "Water",
    duration: 199,
    artist_id: "1816126",
    artist_name: "더보이즈 (THE BOYZ)",
  },
  {
    song_id: 31388213,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZ450kQtx0xrsCGIPYHMJCiw=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10217163.jpg",
    title: "라비앙로즈 (La Vie en Rose)",
    duration: 219,
    artist_id: "2398653",
    artist_name: "IZ*ONE (아이즈원)",
  },
  {
    song_id: 34626109,
    music:
      "https://api1.indj.club/api/v3/music/file?code=rWOLfpSPOaveP1m1KJ+6kL3HxgKaEr1Bwm2v2UHU3RA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10863559.jpg",
    title: "INVU",
    duration: 205,
    artist_id: "236797",
    artist_name: "TAEYEON (태연)",
  },
  {
    song_id: 34808386,
    music:
      "https://api1.indj.club/api/v3/music/file?code=rWOLfpSPOaveP1m1KJ+6kNkXsaH1l6ExYtAe7kKIyj4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10901248.jpg",
    title: "Real Love",
    duration: 202,
    artist_id: "857994",
    artist_name: "오마이걸 (OH MY GIRL)",
  },
  {
    song_id: 5462606,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9OdlmrQQpthWBi5wZxEea20hcB1RU6OgTd/hgeXcXPQ=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2289906.jpg",
    title: "Candy Jelly Love",
    duration: 224,
    artist_id: "789331",
    artist_name: "러블리즈",
  },
  {
    song_id: 33430095,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdSzHmmtp98GOfx0RyjQklto=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10596629.jpg",
    title: "기다릴게",
    duration: 250,
    artist_id: "43806,500423",
    artist_name: "하동균,봉구",
  },
  {
    song_id: 35875407,
    music:
      "https://api1.indj.club/api/v3/music/file?code=LBvyBmXEGFCFltJH2i7UOPiU2Yly89yLC2A9daWljwY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11112176.jpg",
    title: "Cheshire",
    duration: 182,
    artist_id: "2622030",
    artist_name: "ITZY (있지)",
  },
  {
    song_id: 36137552,
    music:
      "https://api1.indj.club/api/v3/music/file?code=OhorDShJBVoSZMiDvS7xhWEKZCWI5A4hPjfS6gHh1xg=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11173138.jpg",
    title: "Rising",
    duration: 160,
    artist_id: "3137294",
    artist_name: "tripleS (트리플에스)",
  },
  {
    song_id: 35504734,
    music:
      "https://api1.indj.club/api/v3/music/file?code=LBvyBmXEGFCFltJH2i7UONMW9LrbaYHbkXbGVv/wyPA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11023224.jpg",
    title: "FOREVER 1",
    duration: 202,
    artist_id: "228069",
    artist_name: "GIRLS' GENERATION (소녀시대)",
  },
  {
    song_id: 30870114,
    music:
      "https://api1.indj.club/api/v3/music/file?code=trYdTAfD4PkNjuNqRiTCuZvgj161Ft9auiYRnACa0mw=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10134956.jpg",
    title: "내가 돌아 (NEGA DOLA)",
    duration: 176,
    artist_id: "2165",
    artist_name: "보아 (BoA)",
  },
  {
    song_id: 31885924,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZw90jeDSFsOnWYIy5z4NKHc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10300342.jpg",
    title: "Uh-Oh",
    duration: 207,
    artist_id: "2137482",
    artist_name: "(G)I-dle ((여자)아이들)",
  },
  {
    song_id: 33372781,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdV6STW2FE6fJQEMHZf94+Ew=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10554246.jpg",
    title: "라일락",
    duration: 215,
    artist_id: "261143",
    artist_name: "IU (아이유)",
  },
  {
    song_id: 4297326,
    music:
      "https://api1.indj.club/api/v3/music/file?code=2Q5fn6bwL7RHZrS4ujJF52vDZBZ5QxOCU+dfuoVka0U=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2213394.jpg",
    title: "사랑하기 싫어",
    duration: 225,
    artist_id: "46744",
    artist_name: "영지",
  },
  {
    song_id: 32438894,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9F0/l+j0j0SkaEwgsDXcRQzj9nsktZb1fTwOeKQyCWA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10399190.jpg",
    title: "어떻게 지내 (Prod. By VAN.C)",
    duration: 231,
    artist_id: "925515",
    artist_name: "오반 (OVAN)",
  },
  {
    song_id: 33372782,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKde7FDD5jQ9m5xNwmIXGo8Ao=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10554246.jpg",
    title: "Flu",
    duration: 189,
    artist_id: "261143",
    artist_name: "IU (아이유)",
  },
  {
    song_id: 33372783,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdcOZ0FOhF7lOjZ+vOzF6OiA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10554246.jpg",
    title: "Coin",
    duration: 193,
    artist_id: "261143",
    artist_name: "IU (아이유)",
  },
  {
    song_id: 5775986,
    music:
      "https://api1.indj.club/api/v3/music/file?code=Sted2lH2HSgPeNE6qawEKLuCF3qvPA/gLWbDBYpfQCo=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2328888.jpg",
    title: "딱 좋아 (Just right)",
    duration: 222,
    artist_id: "751059",
    artist_name: "GOT7 (갓세븐)",
  },
  {
    song_id: 36416114,
    music:
      "https://api1.indj.club/api/v3/music/file?code=OhorDShJBVoSZMiDvS7xhQIrqVUO5e27J37fCrOzMvM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11236264.jpg",
    title: "Spicy",
    duration: 234,
    artist_id: "2899555",
    artist_name: "aespa",
  },
  {
    song_id: 33372788,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdSXZG2GuonmBiif217zDmjs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10554246.jpg",
    title: "어푸 (Ah puh)",
    duration: 200,
    artist_id: "261143",
    artist_name: "IU (아이유)",
  },
  {
    song_id: 5470838,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9OdlmrQQpthWBi5wZxEea3/d9DlqFq8PF4mh+gKsaJc=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2291669.jpg",
    title: "GOOD BOY",
    duration: 246,
    artist_id: "790881",
    artist_name: "GD X TAEYANG",
  },
  {
    song_id: 36266614,
    music:
      "https://api1.indj.club/api/v3/music/file?code=OhorDShJBVoSZMiDvS7xhS5HqNSK6KTUGsKP/GF/x/I=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11201031.jpg",
    title: "Young, Dumb, Stupid",
    duration: 191,
    artist_id: "3070786",
    artist_name: "NMIXX",
  },
  {
    song_id: 36266615,
    music:
      "https://api1.indj.club/api/v3/music/file?code=OhorDShJBVoSZMiDvS7xhakTGt4zT48dLf6f9bhg1a0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11201031.jpg",
    title: "Love Me Like This",
    duration: 189,
    artist_id: "3070786",
    artist_name: "NMIXX",
  },
  {
    song_id: 31052421,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZ241Y32ljGrkYxZ9w6GTavw=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10163106.jpg",
    title: "밤 (Time for the moon night)",
    duration: 227,
    artist_id: "828478",
    artist_name: "여자친구 (GFRIEND)",
  },
  {
    song_id: 33559180,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdSMNsWL1NYUNkcc+xOE+6ws=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10623687.jpg",
    title: "Alcohol-Free",
    duration: 211,
    artist_id: "905701",
    artist_name: "TWICE (트와이스)",
  },
  {
    song_id: 34847378,
    music:
      "https://api1.indj.club/api/v3/music/file?code=rWOLfpSPOaveP1m1KJ+6kP2dY7MhdTTflsNs76bxtNI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10909179.jpg",
    title: "LOVE DIVE",
    duration: 178,
    artist_id: "3055146",
    artist_name: "IVE (아이브)",
  },
  {
    song_id: 34847379,
    music:
      "https://api1.indj.club/api/v3/music/file?code=rWOLfpSPOaveP1m1KJ+6kNtF5AMnPC8B/1aEHd5ukHs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10909179.jpg",
    title: "ROYAL",
    duration: 207,
    artist_id: "3055146",
    artist_name: "IVE (아이브)",
  },
  {
    song_id: 36110996,
    music:
      "https://api1.indj.club/api/v3/music/file?code=OhorDShJBVoSZMiDvS7xhXQXLsL4ZWQ8FSIdYqUOEe8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11166539.jpg",
    title: "파이팅 해야지 (Feat. 이영지)",
    duration: 204,
    artist_id: "2112233",
    artist_name: "부석순 (SEVENTEEN)",
  },
  {
    song_id: 3111583,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZ1x/UR+MSw4IqjgUVkKrRvQ=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/1143954.jpg",
    title: "Black & White",
    duration: 209,
    artist_id: "482640",
    artist_name: "지나",
  },
  {
    song_id: 33313442,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdTAZO4evVJ/jFlf9jgS8teA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10569757.jpg",
    title: "Beautiful Beautiful",
    duration: 191,
    artist_id: "1865635",
    artist_name: "온앤오프 (ONF)",
  },
  {
    song_id: 35353251,
    music:
      "https://api1.indj.club/api/v3/music/file?code=LBvyBmXEGFCFltJH2i7UOLug7lYenQbrOdHAqEnPKXY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10993611.jpg",
    title: "열이올라요 (Heart Burn)",
    duration: 194,
    artist_id: "22938",
    artist_name: "선미",
  },
  {
    song_id: 31199911,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZ5yw4i/H4mdrm5dzC5MNwPE=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10187136.jpg",
    title: "바다보러갈래 (SEE SEA)",
    duration: 200,
    artist_id: "573812",
    artist_name: "효린",
  },
  {
    song_id: 30143152,
    music:
      "https://api1.indj.club/api/v3/music/file?code=trYdTAfD4PkNjuNqRiTCuey8MyCCrKKE+48YXLaTv9Y=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10022111.jpg",
    title: "Wonderland",
    duration: 200,
    artist_id: "428829",
    artist_name: "Jessica (제시카)",
  },
  {
    song_id: 31345333,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZ9kzuc/y+bIdGML0mj0mZR8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10210361.jpg",
    title: "LOVE BOMB",
    duration: 183,
    artist_id: "2019210",
    artist_name: "프로미스나인",
  },
  {
    song_id: 31879863,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZ2vnYROl0962yvxE8cbPeIQ=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10299371.jpg",
    title: "Chica",
    duration: 193,
    artist_id: "968265",
    artist_name: "청하",
  },
  {
    song_id: 33315511,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdcRAIH18hQpw0u2Si+WtQ9Q=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10570193.jpg",
    title: "멜로디",
    duration: 182,
    artist_id: "2112495",
    artist_name: "ASH ISLAND",
  },
  {
    song_id: 36717264,
    music:
      "https://api1.indj.club/api/v3/music/file?code=OhorDShJBVoSZMiDvS7xhcV0gIjaBnbEH5yR0DypJ9g=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11309832.jpg",
    title: "Get A Guitar",
    duration: 161,
    artist_id: "3478478",
    artist_name: "RIIZE",
  },
  {
    song_id: 35009233,
    music:
      "https://api1.indj.club/api/v3/music/file?code=LBvyBmXEGFCFltJH2i7UOLy+8z6IHZdFzqsruPVU/wc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10939458.jpg",
    title: "FEARLESS",
    duration: 183,
    artist_id: "3092950",
    artist_name: "LE SSERAFIM (르세라핌)",
  },
  {
    song_id: 36717265,
    music:
      "https://api1.indj.club/api/v3/music/file?code=OhorDShJBVoSZMiDvS7xhbSr/4Mck07HJmxd1zKFF7M=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11309832.jpg",
    title: "Memories",
    duration: 179,
    artist_id: "3478478",
    artist_name: "RIIZE",
  },
  {
    song_id: 32498389,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9F0/l+j0j0SkaEwgsDXcRQX4+n0IXzi/fbzwgy15Ag4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10410478.jpg",
    title: "아무렇지 않게, 안녕",
    duration: 223,
    artist_id: "1229685",
    artist_name: "HYNN (박혜원)",
  },
  {
    song_id: 35711701,
    music:
      "https://api1.indj.club/api/v3/music/file?code=LBvyBmXEGFCFltJH2i7UONL6MlQ9hEiNEB1UwO56Prw=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11074309.jpg",
    title: "ILLELLA (일낼라)",
    duration: 167,
    artist_id: "750053",
    artist_name: "마마무 (Mamamoo)",
  },
  {
    song_id: 33549026,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdbHzB3Q5hNq3Dlr9O6lCkPo=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10621353.jpg",
    title: "Don't fight the feeling",
    duration: 177,
    artist_id: "724619",
    artist_name: "EXO",
  },
  {
    song_id: 4184826,
    music:
      "https://api1.indj.club/api/v3/music/file?code=yp72jnZLRgLXyQusrjNAdOoEsP1VvVFex1ZQk+PeJ9M=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2194266.jpg",
    title: "첫 사랑니 (Rum Pum Pum Pum)",
    duration: 198,
    artist_id: "428501",
    artist_name: "f(x)",
  },
  {
    song_id: 35640077,
    music:
      "https://api1.indj.club/api/v3/music/file?code=LBvyBmXEGFCFltJH2i7UOGjvalfHJv+EHmIcNRYrkk0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11033394.jpg",
    title: "Shut Down",
    duration: 184,
    artist_id: "995169",
    artist_name: "BLACKPINK",
  },
  {
    song_id: 3468048,
    music:
      "https://api1.indj.club/api/v3/music/file?code=rWOLfpSPOaveP1m1KJ+6kJWxXn+gCs/opONFo7K8VkQ=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/1324851.jpg",
    title: "Bubble Pop!",
    duration: 212,
    artist_id: "449401",
    artist_name: "현아",
  },
  {
    song_id: 32938775,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9F0/l+j0j0SkaEwgsDXcRfesrP2K5w5GHK4tLRxMoa8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10492938.jpg",
    title: "사랑해 (I LOVE YOU)",
    duration: 182,
    artist_id: "2880278",
    artist_name: "TREASURE (트레저)",
  },
  {
    song_id: 34153245,
    music:
      "https://api1.indj.club/api/v3/music/file?code=rWOLfpSPOaveP1m1KJ+6kB/+3K06Df6XTHCJMlOKUfA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10751155.jpg",
    title: "Pilot",
    duration: 210,
    artist_id: "991413",
    artist_name: "NCT 127",
  },
  {
    song_id: 31085346,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZ9jFuJF8TjHNARkBTff4Ah8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10168588.jpg",
    title: "rainy day",
    duration: 219,
    artist_id: "10577,670611,968265",
    artist_name: "휘성 (Realslow),태일 (블락비),청하",
  },
  {
    song_id: 31570741,
    music:
      "https://api1.indj.club/api/v3/music/file?code=0x0g1iXTrMSzLLYUHQ7yZziGLjD9hzBKlGYnYSyW7eo=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10244396.jpg",
    title: "너와 나 우리 (Feat. ZELO of B.A.P)",
    duration: 270,
    artist_id: "718655",
    artist_name: "이예준",
  },
  {
    song_id: 33397561,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdf29ZEahccNDHp5ODC3/Trg=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10589127.jpg",
    title: "ASAP",
    duration: 195,
    artist_id: "2899290",
    artist_name: "STAYC(스테이씨)",
  },
  {
    song_id: 8244031,
    music:
      "https://api1.indj.club/api/v3/music/file?code=r1xnndbK4jwpnCTQhQOoUVrgVrNQCkY5EpkX1zowCgg=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2693802.jpg",
    title: "Starlight (Feat. DEAN)",
    duration: 224,
    artist_id: "236797",
    artist_name: "TAEYEON (태연)",
  },
  {
    song_id: 32217921,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9F0/l+j0j0SkaEwgsDXcRYgXou8mSjiyeNGD+w/3uNM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10357878.jpg",
    title: "Obsession",
    duration: 204,
    artist_id: "724619",
    artist_name: "EXO",
  },
  {
    song_id: 34356045,
    music:
      "https://api1.indj.club/api/v3/music/file?code=rWOLfpSPOaveP1m1KJ+6kIYKhvohwVhuw24yIoA43QU=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10800612.jpg",
    title: "Universe (Let's Play Ball)",
    duration: 232,
    artist_id: "960278",
    artist_name: "NCT U",
  },
  {
    song_id: 4840271,
    music:
      "https://api1.indj.club/api/v3/music/file?code=t5PoMbgbrgPTgjqW3X8QM0C7vO0r4CC6cDaWFPkKSUo=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2277372.jpg",
    title: "위아래",
    duration: 190,
    artist_id: "630454",
    artist_name: "EXID",
  },
  {
    song_id: 32125778,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9F0/l+j0j0SkaEwgsDXcReGRNWF4glkcP43AkH6QZpI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10343701.jpg",
    title: "Sorry",
    duration: 219,
    artist_id: "686920",
    artist_name: "AOA",
  },
  {
    song_id: 34997078,
    music:
      "https://api1.indj.club/api/v3/music/file?code=rWOLfpSPOaveP1m1KJ+6kHVZ7n4jl+59iFiNz04o8as=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10937474.jpg",
    title: "That That (prod. & feat. SUGA of BTS)",
    duration: 174,
    artist_id: "3865",
    artist_name: "PSY (싸이)",
  },
  {
    song_id: 34997079,
    music:
      "https://api1.indj.club/api/v3/music/file?code=rWOLfpSPOaveP1m1KJ+6kFy12/uIfcDd3lzgbST/C7Q=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10937474.jpg",
    title: "Celeb",
    duration: 200,
    artist_id: "3865",
    artist_name: "PSY (싸이)",
  },
  {
    song_id: 34349913,
    music:
      "https://api1.indj.club/api/v3/music/file?code=rWOLfpSPOaveP1m1KJ+6kBqEiDCJs+at3HzxjAgqNro=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10798794.jpg",
    title: "ELEVEN",
    duration: 179,
    artist_id: "3055146",
    artist_name: "IVE (아이브)",
  },
  {
    song_id: 33487708,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FJIwAJbMYtEkwRA/emrKdW93rWKmGXVapz0gexvMkmY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10609342.jpg",
    title: "WE GO",
    duration: 176,
    artist_id: "2019210",
    artist_name: "프로미스나인",
  },
  {
    song_id: 30387038,
    music:
      "https://api1.indj.club/api/v3/music/file?code=trYdTAfD4PkNjuNqRiTCuY/lXEumOhx2pVQQX2y0dts=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10058095.jpg",
    title: "어마어마해",
    duration: 197,
    artist_id: "1221596",
    artist_name: "모모랜드 (MOMOLAND)",
  },
  {
    song_id: 33180518,
    music:
      "https://api1.indj.club/api/v3/music/file?code=PJ7aH7F7kRaM69SujwhNNMGdLtSfg31hPaNo3ApIoa8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10543164.jpg",
    title: "Your Lights",
    duration: 224,
    artist_id: "214784",
    artist_name: "이수 (엠씨더맥스)",
  },
  {
    song_id: 1928044,
    music:
      "https://api1.indj.club/api/v3/music/file?code=m/ddlJC/f2bV+y87Dq53qC/3oh4ti9ehGNI50QVviRk=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/397892.jpg",
    title: "미쳤어 (Feat. 에릭)",
    duration: 243,
    artist_id: "226582",
    artist_name: "손담비",
  },
  {
    song_id: 8127341,
    music:
      "https://api1.indj.club/api/v3/music/file?code=sUVnO9jJxV7Ob0rwTUUxfPTrLp3xuJBxshTfnTOLyxg=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2677235.jpg",
    title: "기대해도 좋은 날",
    duration: 194,
    artist_id: "750053",
    artist_name: "마마무 (Mamamoo)",
  },
  {
    song_id: 30767984,
    music:
      "https://api1.indj.club/api/v3/music/file?code=Yhz/VTermgBXZ7s4joudAUkTA7XsRuEhVBrg3cOwWtk=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10116876.jpg",
    title: "Lip & Hip",
    duration: 210,
    artist_id: "449401",
    artist_name: "현아",
  },
  {
    song_id: 30147445,
    music:
      "https://api1.indj.club/api/v3/music/file?code=Yhz/VTermgBXZ7s4joudAXmuSOx3b0ZIJywIKjtr1RA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10022709.jpg",
    title: "에라 모르겠다",
    duration: 232,
    artist_id: "198094",
    artist_name: "BIGBANG",
  },
  {
    song_id: 32772984,
    music:
      "https://api1.indj.club/api/v3/music/file?code=aaOSXSxuYUlyWKeVyeCSBlHiUKevIOzLz5slB859YMo=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10459845.jpg",
    title: "Apple",
    duration: 207,
    artist_id: "828478",
    artist_name: "여자친구 (GFRIEND)",
  },
  {
    song_id: 30147451,
    music:
      "https://api1.indj.club/api/v3/music/file?code=Yhz/VTermgBXZ7s4joudASDsq5PpLgE0PMjQo1zvVNM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10022709.jpg",
    title: "뱅뱅뱅 (BANG BANG BANG)",
    duration: 220,
    artist_id: "198094",
    artist_name: "BIGBANG",
  },
  {
    song_id: 36356993,
    music:
      "https://api1.indj.club/api/v3/music/file?code=NeXBpjwFyuz+hTAApIDV2Fo70yhlR+PO4QyFyNKyjag=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11211297.jpg",
    title: "I AM",
    duration: 181,
    artist_id: "3055146",
    artist_name: "IVE (아이브)",
  },
  {
    song_id: 3957639,
    music:
      "https://api1.indj.club/api/v3/music/file?code=C3rde7ngDNQ4Uk75NDytAiZNybkWZbzpRyMHBVS8SQo=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2166544.jpg",
    title: "걸어 본다",
    duration: 217,
    artist_id: "535440",
    artist_name: "B1A4",
  },
  {
    song_id: 31286161,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B8f1BBxaWz7TuihSMdvjg69TzxecpGZlGpijne5d/uc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10200838.jpg",
    title: "사이렌 (Siren)",
    duration: 199,
    artist_id: "22938",
    artist_name: "선미",
  },
  {
    song_id: 31556500,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B8f1BBxaWz7TuihSMdvjg7AWxxo7f6oCH1JYe+lmdbc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10242169.jpg",
    title: "해야 (Sunrise)",
    duration: 216,
    artist_id: "828478",
    artist_name: "여자친구 (GFRIEND)",
  },
  {
    song_id: 32445339,
    music:
      "https://api1.indj.club/api/v3/music/file?code=aaOSXSxuYUlyWKeVyeCSBtNu9p2bXkQa0wk5OUN7Vtc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10400522.jpg",
    title: "WANNABE",
    duration: 191,
    artist_id: "2622030",
    artist_name: "ITZY (있지)",
  },
  {
    song_id: 32924578,
    music:
      "https://api1.indj.club/api/v3/music/file?code=aaOSXSxuYUlyWKeVyeCSBu0gQrK0nltkV5Xes0Nb1uI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10490197.jpg",
    title: "널 사랑했던 한 사람",
    duration: 236,
    artist_id: "749640",
    artist_name: "펀치 (Punch)",
  },
  {
    song_id: 35668899,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QB0e9jHMMNUUB07nwgfEoA9/Iz1ux7z/FNBL/e5d4GQ=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11063205.jpg",
    title: "딱 10CM만",
    duration: 195,
    artist_id: "468244,2744750",
    artist_name: "10CM,BIG Naughty (서동현)",
  },
  {
    song_id: 36318125,
    music:
      "https://api1.indj.club/api/v3/music/file?code=NeXBpjwFyuz+hTAApIDV2Pp2oUpVSZMmwAnFp8GHkVM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11211297.jpg",
    title: "Kitsch",
    duration: 183,
    artist_id: "3055146",
    artist_name: "IVE (아이브)",
  },
  {
    song_id: 4840373,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QkvkvFQzOt7/JWjSCQMcw3i1dFBTOrGGxqUH4VEKwg8=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2277388.jpg",
    title: "I Swear",
    duration: 237,
    artist_id: "473181",
    artist_name: "씨스타",
  },
  {
    song_id: 36430773,
    music:
      "https://api1.indj.club/api/v3/music/file?code=NeXBpjwFyuz+hTAApIDV2PNQvX1k0ZDqvSVUeB5bc9s=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11240232.jpg",
    title: "퀸카 (Queencard)",
    duration: 161,
    artist_id: "2137482",
    artist_name: "(G)I-dle ((여자)아이들)",
  },
  {
    song_id: 34808759,
    music:
      "https://api1.indj.club/api/v3/music/file?code=xy118n9Nh3CTSlCoe/N/0uAyI1Zz71ZoBRzmfX2rXA4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10901349.jpg",
    title: "버퍼링 (Glitch Mode)",
    duration: 208,
    artist_id: "1066419",
    artist_name: "NCT DREAM",
  },
  {
    song_id: 4152253,
    music:
      "https://api1.indj.club/api/v3/music/file?code=vG37zWdQPZOHF/gl3BmOyO5tOdrYLnsjvxtR/3ZOJAw=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2190068.jpg",
    title: "여자 대통령",
    duration: 213,
    artist_id: "482762",
    artist_name: "걸스데이",
  },
  {
    song_id: 31161280,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B8f1BBxaWz7TuihSMdvjg7FvyHTWYFdkMLjTe/FW4AA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10181013.jpg",
    title: "1도 없어",
    duration: 199,
    artist_id: "534360",
    artist_name: "Apink (에이핑크)",
  },
  {
    song_id: 35482567,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QB0e9jHMMNUUB07nwgfEoMwldebK0/amJ3l/lyBIr3o=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11017445.jpg",
    title: "WHAT IF",
    duration: 201,
    artist_id: "1229243",
    artist_name: "강승식",
  },
  {
    song_id: 36752334,
    music:
      "https://api1.indj.club/api/v3/music/file?code=NeXBpjwFyuz+hTAApIDV2FCPmWvU0eERVKJ2TCY6etQ=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11311144.jpg",
    title: "SEOUL (Such a Beautiful City)",
    duration: 190,
    artist_id: "3064111",
    artist_name: "H1-KEY",
  },
  {
    song_id: 34335697,
    music:
      "https://api1.indj.club/api/v3/music/file?code=xy118n9Nh3CTSlCoe/N/0kQ79SXyUIPEvnlv/341eE4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10795285.jpg",
    title: "Killing Me",
    duration: 165,
    artist_id: "968265",
    artist_name: "청하",
  },
  {
    song_id: 3156949,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B8f1BBxaWz7TuihSMdvjgxNDsyqcW/A9USp9Rk8QBls=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/1184151.jpg",
    title: "HANDS UP",
    duration: 157,
    artist_id: "198094",
    artist_name: "BIGBANG",
  },
  {
    song_id: 33805289,
    music:
      "https://api1.indj.club/api/v3/music/file?code=PJ7aH7F7kRaM69SujwhNNFUcXMzG+4EVA6xtFGeej3I=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10680450.jpg",
    title: "Queendom",
    duration: 182,
    artist_id: "780066",
    artist_name: "Red Velvet (레드벨벳)",
  },
  {
    song_id: 5616620,
    music:
      "https://api1.indj.club/api/v3/music/file?code=jUlV1np+d/XdMkwe15PosLKBREi9BwOb1ne9S9IvrIw=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2306985.jpg",
    title: "촉이 와 (Can You Feel It?)",
    duration: 209,
    artist_id: "838961",
    artist_name: "SUPER JUNIOR-D&E",
  },
  {
    song_id: 33029109,
    music:
      "https://api1.indj.club/api/v3/music/file?code=PJ7aH7F7kRaM69SujwhNNF1CIGbEMg6hoIt1Bc5DVRQ=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10511553.jpg",
    title: "도망가",
    duration: 146,
    artist_id: "742773",
    artist_name: "MINO (송민호)",
  },
  {
    song_id: 32525311,
    music:
      "https://api1.indj.club/api/v3/music/file?code=aaOSXSxuYUlyWKeVyeCSBqpvGc8fVVIejknrlHC3C2Q=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10416034.jpg",
    title: "사실 나는 (Feat.전건호)",
    duration: 254,
    artist_id: "2863470",
    artist_name: "경서예지",
  },
  {
    song_id: 30403592,
    music:
      "https://api1.indj.club/api/v3/music/file?code=Yhz/VTermgBXZ7s4joudAfmF+76i/QVbd+r8F92WZCI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10060647.jpg",
    title: "LOVE (Feat. 태양)",
    duration: 220,
    artist_id: "3865",
    artist_name: "PSY (싸이)",
  },
  {
    song_id: 32834569,
    music:
      "https://api1.indj.club/api/v3/music/file?code=aaOSXSxuYUlyWKeVyeCSBt6DkVdpr5jnhlfDSBdS5wM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10471178.jpg",
    title: "버닝파워",
    duration: 211,
    artist_id: "2883299",
    artist_name: "마카마카 (Maka' Maka)",
  },
  {
    song_id: 34061322,
    music:
      "https://api1.indj.club/api/v3/music/file?code=xy118n9Nh3CTSlCoe/N/0jk38Qd7K0zQ2IiOEdmInLo=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10735654.jpg",
    title: "사랑은 늘 도망가",
    duration: 243,
    artist_id: "994944",
    artist_name: "임영웅",
  },
  {
    song_id: 34538515,
    music:
      "https://api1.indj.club/api/v3/music/file?code=xy118n9Nh3CTSlCoe/N/0sWqCuDokqwv177Qz6kzEDs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10842611.jpg",
    title: "SMILEY (Feat. BIBI)",
    duration: 174,
    artist_id: "2399724",
    artist_name: "YENA (최예나)",
  },
  {
    song_id: 3822622,
    music:
      "https://api1.indj.club/api/v3/music/file?code=EmBKVMJ01JjJW7BA1UeeXZmGm2STg+WdSELrZN/pGks=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2126375.jpg",
    title: "Electric Shock",
    duration: 197,
    artist_id: "428501",
    artist_name: "f(x)",
  },
  {
    song_id: 35413033,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QB0e9jHMMNUUB07nwgfEoBrnoWbgP/R8dtl+4CSsBZQ=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11004992.jpg",
    title: "SNEAKERS",
    duration: 185,
    artist_id: "2622030",
    artist_name: "ITZY (있지)",
  },
  {
    song_id: 31444012,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B8f1BBxaWz7TuihSMdvjg12d8K5/PezYEnY6DFZZ3fk=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10225410.jpg",
    title: "2 soon",
    duration: 207,
    artist_id: "2402797",
    artist_name: "keshi",
  },
  {
    song_id: 33043504,
    music:
      "https://api1.indj.club/api/v3/music/file?code=PJ7aH7F7kRaM69SujwhNNP3WCC3A4Hbs9TjFLXVaW0U=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10514407.jpg",
    title: "가을밤에 든 생각",
    duration: 187,
    artist_id: "772253",
    artist_name: "잔나비",
  },
  {
    song_id: 34544690,
    music:
      "https://api1.indj.club/api/v3/music/file?code=xy118n9Nh3CTSlCoe/N/0iMOPIY0LpwZK1c7eElJkR0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10844165.jpg",
    title: "LUNATIC",
    duration: 206,
    artist_id: "756529",
    artist_name: "문별 (마마무)",
  },
  {
    song_id: 31964215,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B8f1BBxaWz7TuihSMdvjg9V8HSu056pq56jQUT4MeBs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10313738.jpg",
    title: "The Only (Feat. 아이린 of Red Velvet)",
    duration: 187,
    artist_id: "1383091",
    artist_name: "Raiden",
  },
  {
    song_id: 4193337,
    music:
      "https://api1.indj.club/api/v3/music/file?code=vG37zWdQPZOHF/gl3BmOyOoiQsJIJx+Z6qQ/Bp7Mlfk=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2195303.jpg",
    title: "으르렁 (Growl)",
    duration: 207,
    artist_id: "724619",
    artist_name: "EXO",
  },
  {
    song_id: 35314754,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QB0e9jHMMNUUB07nwgfEoPTBrw0qxylwZJqcFyxZnmg=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10986617.jpg",
    title: "Flip That",
    duration: 178,
    artist_id: "1229429",
    artist_name: "이달의 소녀",
  },
  {
    song_id: 31097925,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B8f1BBxaWz7TuihSMdvjgyDNAIWT7ZjYI5lJiujKdLc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10170914.jpg",
    title: "데리러 가 (Good Evening)",
    duration: 224,
    artist_id: "247639",
    artist_name: "SHINee (샤이니)",
  },
  {
    song_id: 4516940,
    music:
      "https://api1.indj.club/api/v3/music/file?code=3gJ/e7eWa13tDdmYnwRpVFtcnDr0nwDtiUUsDmM5Y6I=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2241591.jpg",
    title: "오늘 뭐해",
    duration: 206,
    artist_id: "417985",
    artist_name: "4minute",
  },
  {
    song_id: 8254545,
    music:
      "https://api1.indj.club/api/v3/music/file?code=juBSFK/Xzt/4xkS0m95KEVdtg387NxPT0XOVGU7kCds=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2695552.jpg",
    title: "Why So Lonely",
    duration: 207,
    artist_id: "217764",
    artist_name: "원더걸스",
  },
  {
    song_id: 32183386,
    music:
      "https://api1.indj.club/api/v3/music/file?code=aaOSXSxuYUlyWKeVyeCSBlurKFYjXSv2yT1C/UnbI9s=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10346650.jpg",
    title: "Blueming",
    duration: 217,
    artist_id: "261143",
    artist_name: "IU (아이유)",
  },
  {
    song_id: 36359275,
    music:
      "https://api1.indj.club/api/v3/music/file?code=NeXBpjwFyuz+hTAApIDV2NN7PYaUOKPGWuNvpLLQHAM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11221404.jpg",
    title: "KNOCK",
    duration: 174,
    artist_id: "2399731",
    artist_name: "이채연",
  },
  {
    song_id: 36721784,
    music:
      "https://api1.indj.club/api/v3/music/file?code=NeXBpjwFyuz+hTAApIDV2N119JJes7Pvng1Hv2T0F4U=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11311038.jpg",
    title: "PANORAMA",
    duration: 179,
    artist_id: "895741",
    artist_name: "iKON",
  },
  {
    song_id: 33422461,
    music:
      "https://api1.indj.club/api/v3/music/file?code=PJ7aH7F7kRaM69SujwhNNCNRNkxQhlqntuI9sNK80wY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10594831.jpg",
    title: "INSIDE OUT",
    duration: 197,
    artist_id: "640891",
    artist_name: "뉴이스트",
  },
  {
    song_id: 31571074,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B8f1BBxaWz7TuihSMdvjg1dV5sWvk/zeGeWgQ+mT1s0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10244487.jpg",
    title: "Q&A",
    duration: 206,
    artist_id: "2620522",
    artist_name: "체리블렛 (Cherry Bullet)",
  },
  {
    song_id: 35730562,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QB0e9jHMMNUUB07nwgfEoJnV3P0TYj4kY7t5GJ0Lqn4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11078852.jpg",
    title: "Nxde",
    duration: 178,
    artist_id: "2137482",
    artist_name: "(G)I-dle ((여자)아이들)",
  },
  {
    song_id: 36637828,
    music:
      "https://api1.indj.club/api/v3/music/file?code=NeXBpjwFyuz+hTAApIDV2P9K8ERfcU/eW+PGwNShrV0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11290943.jpg",
    title: "여름이 들려 (Summer Comes)",
    duration: 201,
    artist_id: "857994",
    artist_name: "오마이걸 (OH MY GIRL)",
  },
  {
    song_id: 35380366,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QB0e9jHMMNUUB07nwgfEoL6iYSaNWQZnoJFCrSZbtys=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10999428.jpg",
    title: "_WORLD",
    duration: 178,
    artist_id: "861436",
    artist_name: "세븐틴",
  },
  {
    song_id: 30997649,
    music:
      "https://api1.indj.club/api/v3/music/file?code=Yhz/VTermgBXZ7s4joudAeCDRTa5MeHrTz5LyNjny54=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10154916.jpg",
    title: "EVERYDAY",
    duration: 206,
    artist_id: "775197",
    artist_name: "WINNER",
  },
  {
    song_id: 34266258,
    music:
      "https://api1.indj.club/api/v3/music/file?code=xy118n9Nh3CTSlCoe/N/0uRa8Zq2mqHwVkSMRtJVEBI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10777679.jpg",
    title: "TIKI TAKA",
    duration: 197,
    artist_id: "412000",
    artist_name: "티아라",
  },
  {
    song_id: 32224409,
    music:
      "https://api1.indj.club/api/v3/music/file?code=aaOSXSxuYUlyWKeVyeCSBiQ6dKZ67qJDXmAmbHQ6i6g=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10359204.jpg",
    title: "반만",
    duration: 244,
    artist_id: "695512",
    artist_name: "진민호",
  },
  {
    song_id: 31403163,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B8f1BBxaWz7TuihSMdvjg1x0w5w1vxqBeAIMuPoxy2U=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10219298.jpg",
    title: "YES or YES",
    duration: 237,
    artist_id: "905701",
    artist_name: "TWICE (트와이스)",
  },
  {
    song_id: 30715044,
    music:
      "https://api1.indj.club/api/v3/music/file?code=Yhz/VTermgBXZ7s4joudAfSzWz3NRymJC1ddyhZAnmc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10109536.jpg",
    title: "DRAMARAMA",
    duration: 186,
    artist_id: "791216",
    artist_name: "몬스타엑스",
  },
  {
    song_id: 35876006,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QB0e9jHMMNUUB07nwgfEoGupaEkQodOOmmT2ikWZnJo=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11112312.jpg",
    title: "WHEN I MOVE",
    duration: 179,
    artist_id: "222128",
    artist_name: "카라",
  },
  {
    song_id: 32490666,
    music:
      "https://api1.indj.club/api/v3/music/file?code=aaOSXSxuYUlyWKeVyeCSBmiuG0ibR+TUeHoZED+EkQM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10408925.jpg",
    title: "안녕, 오늘의 그대에게",
    duration: 223,
    artist_id: "471741",
    artist_name: "임한별",
  },
  {
    song_id: 30287019,
    music:
      "https://api1.indj.club/api/v3/music/file?code=Yhz/VTermgBXZ7s4joudAT2wxcyFzFGuyqAnFueJTqc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10043575.jpg",
    title: "롤린 (Rollin')",
    duration: 198,
    artist_id: "531700",
    artist_name: "브레이브걸스",
  },
  {
    song_id: 4693165,
    music:
      "https://api1.indj.club/api/v3/music/file?code=2MFZc8uT2Hn5ESFQOBoKBINHRj7OkmOmEAjHciCSGuI=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2261569.jpg",
    title: "단발머리 (Short Hair)",
    duration: 215,
    artist_id: "686920",
    artist_name: "AOA",
  },
  {
    song_id: 32273582,
    music:
      "https://api1.indj.club/api/v3/music/file?code=aaOSXSxuYUlyWKeVyeCSBjhgiNRKtoZLZzI2M3NRgTI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10368053.jpg",
    title: "Psycho",
    duration: 211,
    artist_id: "780066",
    artist_name: "Red Velvet (레드벨벳)",
  },
  {
    song_id: 32941231,
    music:
      "https://api1.indj.club/api/v3/music/file?code=aaOSXSxuYUlyWKeVyeCSBoUo/w7G5Dhfqs3OR62tO3g=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10493563.jpg",
    title: "그리워하면 그댈 만날까봐",
    duration: 207,
    artist_id: "735094",
    artist_name: "김나영",
  },
  {
    song_id: 33133746,
    music:
      "https://api1.indj.club/api/v3/music/file?code=PJ7aH7F7kRaM69SujwhNNBD9PkFs90v/dq/Vwlcdg6Q=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10532899.jpg",
    title: "r u ok",
    duration: 186,
    artist_id: "2631146",
    artist_name: "Tate McRae",
  },
  {
    song_id: 32961719,
    music:
      "https://api1.indj.club/api/v3/music/file?code=aaOSXSxuYUlyWKeVyeCSBoWIBgm5wM0NMSYZuohRf7I=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10498032.jpg",
    title: "Crazy Over You",
    duration: 162,
    artist_id: "995169",
    artist_name: "BLACKPINK",
  },
  {
    song_id: 36078777,
    music:
      "https://api1.indj.club/api/v3/music/file?code=NeXBpjwFyuz+hTAApIDV2FqyH6RVVITsHfkmMlKqZi0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11158153.jpg",
    title: "Sugar Rush Ride",
    duration: 186,
    artist_id: "2632253",
    artist_name: "투모로우바이투게더",
  },
  {
    song_id: 33655994,
    music:
      "https://api1.indj.club/api/v3/music/file?code=PJ7aH7F7kRaM69SujwhNNAdmnT+6zLlp7DQ9UmzWPj8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10645654.jpg",
    title: "Weekend",
    duration: 234,
    artist_id: "236797",
    artist_name: "TAEYEON (태연)",
  },
  {
    song_id: 3886294,
    music:
      "https://api1.indj.club/api/v3/music/file?code=EmBKVMJ01JjJW7BA1UeeXV3dvgo2lrmXLqsFN/z4FUg=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2146186.jpg",
    title: "Pandora",
    duration: 193,
    artist_id: "222128",
    artist_name: "카라",
  },
  {
    song_id: 5692635,
    music:
      "https://api1.indj.club/api/v3/music/file?code=jUlV1np+d/XdMkwe15PosHeb1rHyi5WckEduvZMzkCg=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2316838.jpg",
    title: "Kiss My Lips",
    duration: 226,
    artist_id: "2165",
    artist_name: "보아 (BoA)",
  },
  {
    song_id: 33666269,
    music:
      "https://api1.indj.club/api/v3/music/file?code=PJ7aH7F7kRaM69SujwhNNACVCIavPlRDG7i9sHsbQp8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10648182.jpg",
    title: "Permission to Dance",
    duration: 188,
    artist_id: "672375",
    artist_name: "BTS",
  },
  {
    song_id: 32693476,
    music:
      "https://api1.indj.club/api/v3/music/file?code=aaOSXSxuYUlyWKeVyeCSBiBIVRAnj8Ovz+XwJkP+IQI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10446849.jpg",
    title: "OOPSY",
    duration: 195,
    artist_id: "1816806",
    artist_name: "위키미키 (Weki Meki)",
  },
  {
    song_id: 31792360,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B8f1BBxaWz7TuihSMdvjg7uUelk6pfm6tmBC/XKYEmE=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10284331.jpg",
    title: "오월의 어느 봄날 (Feat. 첸(CHEN))",
    duration: 253,
    artist_id: "471741",
    artist_name: "임한별",
  },
  {
    song_id: 35560680,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QB0e9jHMMNUUB07nwgfEoIZfcWANfiXQNwGAZ55onE4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11038172.jpg",
    title: "Talk that Talk",
    duration: 175,
    artist_id: "905701",
    artist_name: "TWICE (트와이스)",
  },
  {
    song_id: 31542508,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B8f1BBxaWz7TuihSMdvjg5mxOa24QITm9nbCzNfQoVo=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10239951.jpg",
    title: "%% (응응)",
    duration: 208,
    artist_id: "534360",
    artist_name: "Apink (에이핑크)",
  },
  {
    song_id: 4478191,
    music:
      "https://api1.indj.club/api/v3/music/file?code=yQUSmc57x42N8XRKE1lVjNVnenxLX3kq0IzgU8vJzJA=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2236445.jpg",
    title: "멘붕 (CL Solo)",
    duration: 196,
    artist_id: "406712",
    artist_name: "2NE1",
  },
  {
    song_id: 4381937,
    music:
      "https://api1.indj.club/api/v3/music/file?code=IULh4H4wjZiEXtW/KLb9x7ur6PEFQMzd+DBFOKKwVbk=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2224087.jpg",
    title: "Something",
    duration: 241,
    artist_id: "108316",
    artist_name: "동방신기 (TVXQ!)",
  },
  {
    song_id: 8129783,
    music:
      "https://api1.indj.club/api/v3/music/file?code=sUVnO9jJxV7Ob0rwTUUxfIcNgDVEOrp8W1S+MiYzI9A=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2677563.jpg",
    title: "Crush",
    duration: 213,
    artist_id: "960251",
    artist_name: "아이오아이 (I.O.I)",
  },
  {
    song_id: 30565630,
    music:
      "https://api1.indj.club/api/v3/music/file?code=Yhz/VTermgBXZ7s4joudAZ3RO8V5QzK0zguWWZAAys0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10085546.jpg",
    title: "Holiday",
    duration: 200,
    artist_id: "228069",
    artist_name: "GIRLS' GENERATION (소녀시대)",
  },
  {
    song_id: 4764928,
    music:
      "https://api1.indj.club/api/v3/music/file?code=KPqXby1U8YMMcozk4ZKvbWEPsfLY1MvqUu6oJ82ailg=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2250057.jpg",
    title: "HER",
    duration: 179,
    artist_id: "532201",
    artist_name: "블락비 (Block B)",
  },
  {
    song_id: 35493135,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QB0e9jHMMNUUB07nwgfEoA93osPL3ofBXcqIsR1oThY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11020241.jpg",
    title: "SMARTPHONE",
    duration: 199,
    artist_id: "2399724",
    artist_name: "YENA (최예나)",
  },
  {
    song_id: 34643252,
    music:
      "https://api1.indj.club/api/v3/music/file?code=xy118n9Nh3CTSlCoe/N/0lI0YpoDDEqFgaHu9i/n00o=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10868472.jpg",
    title: "직진 (JIKJIN)",
    duration: 185,
    artist_id: "2880278",
    artist_name: "TREASURE (트레저)",
  },
  {
    song_id: 30838076,
    music:
      "https://api1.indj.club/api/v3/music/file?code=Yhz/VTermgBXZ7s4joudAZCCjWPaDryVa9TUMB4jQRs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10128855.jpg",
    title: "주인공",
    duration: 194,
    artist_id: "22938",
    artist_name: "선미",
  },
  {
    song_id: 33002813,
    music:
      "https://api1.indj.club/api/v3/music/file?code=PJ7aH7F7kRaM69SujwhNNB98KGAmaU95lF3Z4+HLVck=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10506084.jpg",
    title: "사랑 못해, 남들 쉽게 다 하는 거",
    duration: 261,
    artist_id: "175155",
    artist_name: "먼데이 키즈 (Monday Kiz)",
  },
  {
    song_id: 36105548,
    music:
      "https://api1.indj.club/api/v3/music/file?code=NeXBpjwFyuz+hTAApIDV2Ca2lRwrl6aaF54Uxhp9y5A=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11165170.jpg",
    title: "Teddy Bear",
    duration: 190,
    artist_id: "2899290",
    artist_name: "STAYC(스테이씨)",
  },
  {
    song_id: 36105549,
    music:
      "https://api1.indj.club/api/v3/music/file?code=NeXBpjwFyuz+hTAApIDV2NppuVgZrqiR8qh+9nI0XVk=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11165170.jpg",
    title: "Poppy (Korean Ver.)",
    duration: 179,
    artist_id: "2899290",
    artist_name: "STAYC(스테이씨)",
  },
  {
    song_id: 32681306,
    music:
      "https://api1.indj.club/api/v3/music/file?code=aaOSXSxuYUlyWKeVyeCSBsuhMoT20pl8FooPEcpdZZs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10444798.jpg",
    title: "환상동화 (Secret Story of the Swan)",
    duration: 192,
    artist_id: "2398653",
    artist_name: "IZ*ONE (아이즈원)",
  },
  {
    song_id: 2948449,
    music:
      "https://api1.indj.club/api/v3/music/file?code=Be66h5lrgCB9WL9QoV10h1yc7vnxmaIdpMpC3O2bgoU=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/1028251.jpg",
    title: "Breathe",
    duration: 213,
    artist_id: "481481",
    artist_name: "미쓰에이",
  },
  {
    song_id: 31149418,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B8f1BBxaWz7TuihSMdvjg/zVNxGC/iWS2uI4UznCI0I=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10179169.jpg",
    title: "BAAM",
    duration: 208,
    artist_id: "1221596",
    artist_name: "모모랜드 (MOMOLAND)",
  },
  {
    song_id: 31737197,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B8f1BBxaWz7TuihSMdvjg/zBuGjC4PlhZcc/W6lukZY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10273641.jpg",
    title: "작은 것들을 위한 시 (Boy With Luv) (Feat. Halsey)",
    duration: 229,
    artist_id: "672375",
    artist_name: "BTS",
  },
  {
    song_id: 32550256,
    music:
      "https://api1.indj.club/api/v3/music/file?code=aaOSXSxuYUlyWKeVyeCSBmhpROpigzCdwjqcDzgfKwg=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10421256.jpg",
    title: "Oops I’m Sorry",
    duration: 179,
    artist_id: "882818",
    artist_name: "에이프릴 (APRIL)",
  },
  {
    song_id: 33447280,
    music:
      "https://api1.indj.club/api/v3/music/file?code=PJ7aH7F7kRaM69SujwhNNGV1s9xiRt4+KPpFMPChVts=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10600760.jpg",
    title: "마.피.아. In the morning",
    duration: 172,
    artist_id: "2622030",
    artist_name: "ITZY (있지)",
  },
  {
    song_id: 36681074,
    music:
      "https://api1.indj.club/api/v3/music/file?code=NeXBpjwFyuz+hTAApIDV2J9kjeNr2Aj+13ZeZvYFDf8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11300771.jpg",
    title: "Fast Forward",
    duration: 161,
    artist_id: "968260",
    artist_name: "전소미",
  },
  {
    song_id: 35272060,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QB0e9jHMMNUUB07nwgfEoPsOMDKbArTLmbGKrl9lJSA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10979636.jpg",
    title: "Yet To Come",
    duration: 194,
    artist_id: "672375",
    artist_name: "BTS",
  },
  {
    song_id: 35546497,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QB0e9jHMMNUUB07nwgfEoN0u1JT2vSUaN1hkW3fGWYs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11034298.jpg",
    title: "After LIKE",
    duration: 177,
    artist_id: "3055146",
    artist_name: "IVE (아이브)",
  },
  {
    song_id: 35665282,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QB0e9jHMMNUUB07nwgfEoF60jdGeqPGFCX+GgphCshU=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11062364.jpg",
    title: "Rush Hour (Feat. j-hope of BTS)",
    duration: 178,
    artist_id: "674710",
    artist_name: "Crush",
  },
  {
    song_id: 33295747,
    music:
      "https://api1.indj.club/api/v3/music/file?code=PJ7aH7F7kRaM69SujwhNNIF3LwYMRa08Uf+9IQEMRXw=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10566182.jpg",
    title: "함께 했는데 이별은 나 혼자인 거야",
    duration: 205,
    artist_id: "661792",
    artist_name: "소정 (레이디스 코드)",
  },
  {
    song_id: 33303943,
    music:
      "https://api1.indj.club/api/v3/music/file?code=PJ7aH7F7kRaM69SujwhNNDC3FAxZP6JLPemb3hpWin4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10567720.jpg",
    title: "사랑한단 거짓말은 안 할래",
    duration: 244,
    artist_id: "175155,225993",
    artist_name: "먼데이 키즈 (Monday Kiz),최현준 (V.O.S)",
  },
  {
    song_id: 33305996,
    music:
      "https://api1.indj.club/api/v3/music/file?code=PJ7aH7F7kRaM69SujwhNNFgXXSnoAggyDVK9xeGhwvs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10568243.jpg",
    title: "Don't Call Me",
    duration: 220,
    artist_id: "247639",
    artist_name: "SHINee (샤이니)",
  },
  {
    song_id: 35931532,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QB0e9jHMMNUUB07nwgfEoF3S+pxxm0q2R09NODApPqY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11124139.jpg",
    title: "Candy",
    duration: 218,
    artist_id: "1066419",
    artist_name: "NCT DREAM",
  },
  {
    song_id: 35931534,
    music:
      "https://api1.indj.club/api/v3/music/file?code=QB0e9jHMMNUUB07nwgfEoK6OH74KEsTascRrmoEoByI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11124139.jpg",
    title: "Tangerine Love (Favorite)",
    duration: 179,
    artist_id: "1066419",
    artist_name: "NCT DREAM",
  },
  {
    song_id: 33244575,
    music:
      "https://api1.indj.club/api/v3/music/file?code=PJ7aH7F7kRaM69SujwhNNKfkFDXEpfJwTi1TSV1LDi8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10555397.jpg",
    title: "I'm Not Cool",
    duration: 174,
    artist_id: "449401",
    artist_name: "현아",
  },
  {
    song_id: 31448480,
    music:
      "https://api1.indj.club/api/v3/music/file?code=B8f1BBxaWz7TuihSMdvjg2xGNxnXjeD5r5CHKxtxV1E=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10226163.jpg",
    title: "아낙네",
    duration: 208,
    artist_id: "742773",
    artist_name: "MINO (송민호)",
  },
  {
    song_id: 33244576,
    music:
      "https://api1.indj.club/api/v3/music/file?code=GE+hJiB9HWAMCbrT3vqiu0NtBtZD8mOhBgPlVw5lpds=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10555397.jpg",
    title: "GOOD GIRL",
    duration: 185,
    artist_id: "449401",
    artist_name: "현아",
  },
  {
    song_id: 7935396,
    music:
      "https://api1.indj.club/api/v3/music/file?code=J6krhocyv2sMkA/l0zPHqIVk903RW5UyIFsN3RyY9b0=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2651328.jpg",
    title: "HOT PINK",
    duration: 201,
    artist_id: "630454",
    artist_name: "EXID",
  },
  {
    song_id: 31448494,
    music:
      "https://api1.indj.club/api/v3/music/file?code=oZra12yrpXtvZyIkr46fM5/GlJAzKZI3MiKdPcd+6f0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10226164.jpg",
    title: "Forever Yours (Feat. 소유)",
    duration: 208,
    artist_id: "614026",
    artist_name: "키 (KEY)",
  },
  {
    song_id: 2160048,
    music:
      "https://api1.indj.club/api/v3/music/file?code=8FgkqCbdrufaltHloQVV3P6GOEtsUcE/B/GJH799wbQ=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/554651.jpg",
    title: "Fire",
    duration: 223,
    artist_id: "406712",
    artist_name: "2NE1",
  },
  {
    song_id: 31288765,
    music:
      "https://api1.indj.club/api/v3/music/file?code=oZra12yrpXtvZyIkr46fM7atXIKsTrdwvoQWoiIclxw=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10201272.jpg",
    title: "몰랐니 (Lil' Touch)",
    duration: 190,
    artist_id: "2296946",
    artist_name: "소녀시대-Oh!GG",
  },
  {
    song_id: 33940932,
    music:
      "https://api1.indj.club/api/v3/music/file?code=GE+hJiB9HWAMCbrT3vqiu+AHTDshkSIZklz+BODhVZU=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10710695.jpg",
    title: "LALISA",
    duration: 201,
    artist_id: "995172",
    artist_name: "리사 (LISA)",
  },
  {
    song_id: 35945927,
    music:
      "https://api1.indj.club/api/v3/music/file?code=h+ELMhQoO6k57b+aVIeUll57JFTPrUcjsoyHnUZPXIU=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11127145.jpg",
    title: "Ditto",
    duration: 186,
    artist_id: "3114174",
    artist_name: "NewJeans",
  },
  {
    song_id: 32974285,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FXfnY80OXvNz3uGXu5eoEgSGdBTqHwzxVmEmoIjBtfk=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10488883.jpg",
    title: "cheap sunglasses",
    duration: 199,
    artist_id: "2640909",
    artist_name: "John K",
  },
  {
    song_id: 35706322,
    music:
      "https://api1.indj.club/api/v3/music/file?code=h+ELMhQoO6k57b+aVIeUlv8TiVs4Su2JKG6rAr5KUPc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11072730.jpg",
    title: "CASE 143",
    duration: 192,
    artist_id: "2006344",
    artist_name: "Stray Kids (스트레이 키즈)",
  },
  {
    song_id: 2112982,
    music:
      "https://api1.indj.club/api/v3/music/file?code=8FgkqCbdrufaltHloQVV3LpJ/EJWI/4OYni2VaQx3T0=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/524357.jpg",
    title: "토요일밤에",
    duration: 225,
    artist_id: "226582",
    artist_name: "손담비",
  },
  {
    song_id: 4212184,
    music:
      "https://api1.indj.club/api/v3/music/file?code=gcHKmo1eBUZKTMYu4dtSzPaB7VcWBlFL511aGlroZGg=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2197599.jpg",
    title: "24시간이 모자라",
    duration: 202,
    artist_id: "22938",
    artist_name: "선미",
  },
  {
    song_id: 30313945,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9j2je6SybEx4+JRGXl4YshgM5hPpXCqkmfbq5rBfIcM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10047779.jpg",
    title: "WEE WOO",
    duration: 193,
    artist_id: "958953",
    artist_name: "PRISTIN (프리스틴)",
  },
  {
    song_id: 35454425,
    music:
      "https://api1.indj.club/api/v3/music/file?code=h+ELMhQoO6k57b+aVIeUllxA0scY9o3ZkIEOM+Yfb5Y=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11011565.jpg",
    title: "Attention",
    duration: 180,
    artist_id: "3114174",
    artist_name: "NewJeans",
  },
  {
    song_id: 35454426,
    music:
      "https://api1.indj.club/api/v3/music/file?code=h+ELMhQoO6k57b+aVIeUlq4I5VKvUvEs+e5TSLg1CYc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11011565.jpg",
    title: "Hype boy",
    duration: 179,
    artist_id: "3114174",
    artist_name: "NewJeans",
  },
  {
    song_id: 31055324,
    music:
      "https://api1.indj.club/api/v3/music/file?code=oZra12yrpXtvZyIkr46fM+hkJA+jTycXVEM2incX+7A=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10163578.jpg",
    title: "LATATA",
    duration: 203,
    artist_id: "2137482",
    artist_name: "(G)I-dle ((여자)아이들)",
  },
  {
    song_id: 8150494,
    music:
      "https://api1.indj.club/api/v3/music/file?code=MtUZyHSO75budvyysO33VvkXUHec1h77PFbeAr4IG/0=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2680289.jpg",
    title: "다이너마이트",
    duration: 210,
    artist_id: "672560",
    artist_name: "VIXX (빅스)",
  },
  {
    song_id: 35433950,
    music:
      "https://api1.indj.club/api/v3/music/file?code=h+ELMhQoO6k57b+aVIeUlmeME0oE7hhWQTcxJJ6O3Qs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11008344.jpg",
    title: "SEOUL DRIFT",
    duration: 200,
    artist_id: "602056",
    artist_name: "지코 (ZICO)",
  },
  {
    song_id: 34518499,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FQJ7/loFdt97Qf8z8Q+kfnbTJ2yjlrwkjWBf4dR5sTQ=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10837317.jpg",
    title: "Blessed-Cursed",
    duration: 171,
    artist_id: "2899079",
    artist_name: "ENHYPEN",
  },
  {
    song_id: 5674470,
    music:
      "https://api1.indj.club/api/v3/music/file?code=1xnK3D4k56UR2I3ULQfBjuwTk6KlaeiZwfse069RAsY=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2315407.jpg",
    title: "연예할래",
    duration: 191,
    artist_id: "499464",
    artist_name: "박보람",
  },
  {
    song_id: 32749031,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FXfnY80OXvNz3uGXu5eoEl42q7rFnTWNpt0NMcQE9qM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10456137.jpg",
    title: "PLAY (Feat. 창모)",
    duration: 200,
    artist_id: "968265",
    artist_name: "청하",
  },
  {
    song_id: 32001519,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FXfnY80OXvNz3uGXu5eoEtNIw7ceTmwkyUdmJ/dRpvs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10320160.jpg",
    title: "Don't Make Me Laugh",
    duration: 180,
    artist_id: "670711",
    artist_name: "오하영",
  },
  {
    song_id: 31266290,
    music:
      "https://api1.indj.club/api/v3/music/file?code=oZra12yrpXtvZyIkr46fMyYMh4NqO2S4HCx13bYd3Go=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10197480.jpg",
    title: "IDOL",
    duration: 222,
    artist_id: "672375",
    artist_name: "BTS",
  },
  {
    song_id: 8238579,
    music:
      "https://api1.indj.club/api/v3/music/file?code=wylmmPtBH6dd5nmjb5jcfjg8gVH4PUhdsYxeBnCVWQ0=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2692927.jpg",
    title: "하이힐",
    duration: 180,
    artist_id: "531700",
    artist_name: "브레이브걸스",
  },
  {
    song_id: 9604600,
    music:
      "https://api1.indj.club/api/v3/music/file?code=Wgu3SmBAbvx92kM9XCUr5uOZSo9CzLEKZ7eZCRmmwUs=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2704598.jpg",
    title: "비밀이야 (Secret)",
    duration: 223,
    artist_id: "943959",
    artist_name: "우주소녀",
  },
  {
    song_id: 34772475,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FQJ7/loFdt97Qf8z8Q+kfhV9xIufkErjHWpkWT5zUXY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10894554.jpg",
    title: "Feel My Rhythm",
    duration: 211,
    artist_id: "780066",
    artist_name: "Red Velvet (레드벨벳)",
  },
  {
    song_id: 36830723,
    music:
      "https://api1.indj.club/api/v3/music/file?code=6tN6UCCSlHHPVWdNEau8VRhVRKncclhUwUiliOqKus0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11334935.jpg",
    title: "3D (feat. Jack Harlow)",
    duration: 200,
    artist_id: "725987",
    artist_name: "정국",
  },
  {
    song_id: 4101639,
    music:
      "https://api1.indj.club/api/v3/music/file?code=pJ5GdX8NB6UoXRtCOW4Hz7jk6LTYh9muwIPam65+VKU=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2183466.jpg",
    title: "YooHoo (유후)",
    duration: 205,
    artist_id: "435121",
    artist_name: "시크릿",
  },
  {
    song_id: 34491913,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FQJ7/loFdt97Qf8z8Q+kfgBZp3G8as4BUfjSAKfeXxw=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10830226.jpg",
    title: "WA DA DA",
    duration: 184,
    artist_id: "3058246",
    artist_name: "Kep1er (케플러)",
  },
  {
    song_id: 31417871,
    music:
      "https://api1.indj.club/api/v3/music/file?code=oZra12yrpXtvZyIkr46fM2058XNdKAwTvjV6HbODJsU=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10221424.jpg",
    title: "SOLO",
    duration: 169,
    artist_id: "995173",
    artist_name: "제니 (JENNIE)",
  },
  {
    song_id: 33594897,
    music:
      "https://api1.indj.club/api/v3/music/file?code=GE+hJiB9HWAMCbrT3vqiu+yeILTPj9DSXOaCeqMj9V0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10632044.jpg",
    title: "Ready to love",
    duration: 187,
    artist_id: "861436",
    artist_name: "세븐틴",
  },
  {
    song_id: 30512671,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9j2je6SybEx4+JRGXl4Ysj1KgwrUgV9mx53UcO8IJeQ=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10077879.jpg",
    title: "빨간 맛 (Red Flavor)",
    duration: 191,
    artist_id: "780066",
    artist_name: "Red Velvet (레드벨벳)",
  },
  {
    song_id: 34614816,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FQJ7/loFdt97Qf8z8Q+kfi9lDIytvwK3WE0Jk7gY3aI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10861019.jpg",
    title: "BOP BOP!",
    duration: 220,
    artist_id: "2970177",
    artist_name: "VIVIZ (비비지)",
  },
  {
    song_id: 33216036,
    music:
      "https://api1.indj.club/api/v3/music/file?code=GE+hJiB9HWAMCbrT3vqiuyT5a6nloCUokmAwmcyUUNk=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10549554.jpg",
    title: "X (걸어온 길에 꽃밭 따윈 없었죠)",
    duration: 256,
    artist_id: "968265",
    artist_name: "청하",
  },
  {
    song_id: 34496037,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FQJ7/loFdt97Qf8z8Q+kftSvt7gbqUX+aGY21Avj9Ns=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10831326.jpg",
    title: "Fire (With 브랜뉴차일드, 클루씨)",
    duration: 0,
    artist_id: "1050107",
    artist_name: "소연 ((여자)아이들)",
  },
  {
    song_id: 36722213,
    music:
      "https://api1.indj.club/api/v3/music/file?code=6tN6UCCSlHHPVWdNEau8Vaucvit16YmahndYSRIE6CI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11311144.jpg",
    title: "불빛을 꺼뜨리지 마 (Time to Shine)",
    duration: 199,
    artist_id: "3064111",
    artist_name: "H1-KEY",
  },
  {
    song_id: 31194684,
    music:
      "https://api1.indj.club/api/v3/music/file?code=oZra12yrpXtvZyIkr46fM96iZRAh7HzpeOGSklLB8Kc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10186276.jpg",
    title: "RETRO FUTURE",
    duration: 196,
    artist_id: "1703266",
    artist_name: "트리플 H (현아, 펜타곤 (후이, 이던))",
  },
  {
    song_id: 31417922,
    music:
      "https://api1.indj.club/api/v3/music/file?code=oZra12yrpXtvZyIkr46fM6LLZdoNBBYitPLHtzMXm6c=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10215293.jpg",
    title: "아름답고도 아프구나",
    duration: 240,
    artist_id: "647971",
    artist_name: "비투비",
  },
  {
    song_id: 34436674,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FQJ7/loFdt97Qf8z8Q+kfvI5+Av17MDWwUtkk9MhjfM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10818396.jpg",
    title: "Dreams Come True",
    duration: 205,
    artist_id: "2899555",
    artist_name: "aespa",
  },
  {
    song_id: 32243273,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FXfnY80OXvNz3uGXu5eoEtie3SU67ogKH70nsv5MVG4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10362776.jpg",
    title: "Square (2017)",
    duration: 262,
    artist_id: "698776",
    artist_name: "백예린 (Yerin Baek)",
  },
  {
    song_id: 30217810,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9j2je6SybEx4+JRGXl4YstoDAEUv4OgZgK8RlRRU74g=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10031741.jpg",
    title: "Yes No Maybe",
    duration: 187,
    artist_id: "514741",
    artist_name: "수지 (SUZY)",
  },
  {
    song_id: 31196764,
    music:
      "https://api1.indj.club/api/v3/music/file?code=oZra12yrpXtvZyIkr46fM88uAiVcKeocNRhmnbIJlHQ=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10186691.jpg",
    title: "여름여름해 (Sunny Summer)",
    duration: 199,
    artist_id: "828478",
    artist_name: "여자친구 (GFRIEND)",
  },
  {
    song_id: 35219048,
    music:
      "https://api1.indj.club/api/v3/music/file?code=h+ELMhQoO6k57b+aVIeUli5M85DplSi+OhlDRcPwBcU=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10967980.jpg",
    title: "VENOM",
    duration: 200,
    artist_id: "2638386",
    artist_name: "BVNDIT (밴디트)",
  },
  {
    song_id: 5715562,
    music:
      "https://api1.indj.club/api/v3/music/file?code=4KyZiK1C/1WTUBcv+r9OeyNfesomooo5gbTsh0mUNlM=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2320582.jpg",
    title: "Jam Jam",
    duration: 205,
    artist_id: "861436",
    artist_name: "세븐틴",
  },
  {
    song_id: 1683050,
    music:
      "https://api1.indj.club/api/v3/music/file?code=CfxVj3Z1WerSwbBrgo3oodgMfnhhF/HL+6UUjH4rVNo=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/355128.jpg",
    title: "다시 만난 세계 (Into The New World)",
    duration: 265,
    artist_id: "228069",
    artist_name: "GIRLS' GENERATION (소녀시대)",
  },
  {
    song_id: 4138606,
    music:
      "https://api1.indj.club/api/v3/music/file?code=pJ5GdX8NB6UoXRtCOW4Hz5MxcQnw8xU5LYlGUrIQwro=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2188413.jpg",
    title: "Give It To Me",
    duration: 202,
    artist_id: "473181",
    artist_name: "씨스타",
  },
  {
    song_id: 5473905,
    music:
      "https://api1.indj.club/api/v3/music/file?code=XbxzuDOE4jdDqtzf2Mhw2CfnqrImKw5uFEId1itMElM=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2291986.jpg",
    title: "LUV",
    duration: 239,
    artist_id: "534360",
    artist_name: "Apink (에이핑크)",
  },
  {
    song_id: 5697138,
    music:
      "https://api1.indj.club/api/v3/music/file?code=1xnK3D4k56UR2I3ULQfBjsNWccfKTLm+flcE1Yt43uk=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2318539.jpg",
    title: "무단침입 (Trespass)",
    duration: 205,
    artist_id: "791216",
    artist_name: "몬스타엑스",
  },
  {
    song_id: 35389041,
    music:
      "https://api1.indj.club/api/v3/music/file?code=h+ELMhQoO6k57b+aVIeUlvzbNef3W8OW8q+8XYWHXIM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11001072.jpg",
    title: "Sparkling",
    duration: 187,
    artist_id: "968265",
    artist_name: "청하",
  },
  {
    song_id: 30367365,
    music:
      "https://api1.indj.club/api/v3/music/file?code=9j2je6SybEx4+JRGXl4YsuLTedM0w0EwpK6nH5q9d9A=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10055259.jpg",
    title: "BLUE MOON (Prod. GroovyRoom)",
    duration: 203,
    artist_id: "573812,774900",
    artist_name: "효린,창모 (CHANGMO)",
  },
  {
    song_id: 32697989,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FXfnY80OXvNz3uGXu5eoEpHZp7ouWx905VSEhj1PEDs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10447505.jpg",
    title: "My My",
    duration: 185,
    artist_id: "861436",
    artist_name: "세븐틴",
  },
  {
    song_id: 31131274,
    music:
      "https://api1.indj.club/api/v3/music/file?code=oZra12yrpXtvZyIkr46fM1wc/GLmjw+Kos969igW8Jg=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10176415.jpg",
    title: "Forever Young",
    duration: 237,
    artist_id: "995169",
    artist_name: "BLACKPINK",
  },
  {
    song_id: 36263564,
    music:
      "https://api1.indj.club/api/v3/music/file?code=6tN6UCCSlHHPVWdNEau8VY0B8Iuio4x5nAw4rx4fLRI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11153086.jpg",
    title: "SET ME FREE",
    duration: 182,
    artist_id: "905701",
    artist_name: "TWICE (트와이스)",
  },
  {
    song_id: 31817362,
    music:
      "https://api1.indj.club/api/v3/music/file?code=oZra12yrpXtvZyIkr46fMzU1rbjWYCEFzOhjgjyeJPM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10278828.jpg",
    title: "BREATHE",
    duration: 218,
    artist_id: "2640829",
    artist_name: "AB6IX (에이비식스)",
  },
  {
    song_id: 7900822,
    music:
      "https://api1.indj.club/api/v3/music/file?code=J6krhocyv2sMkA/l0zPHqG0Dxz7rnplSOZbjSxsKk+c=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2646918.jpg",
    title: "4 Walls",
    duration: 208,
    artist_id: "428501",
    artist_name: "f(x)",
  },
  {
    song_id: 35337881,
    music:
      "https://api1.indj.club/api/v3/music/file?code=h+ELMhQoO6k57b+aVIeUlpi4ZleDrQqnTqq6GSpdLmY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10991127.jpg",
    title: "Stay This Way",
    duration: 2820,
    artist_id: "2019210",
    artist_name: "프로미스나인",
  },
  {
    song_id: 34311835,
    music:
      "https://api1.indj.club/api/v3/music/file?code=FQJ7/loFdt97Qf8z8Q+kft0PmsoyJp11iOBPAFF/YnM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10788595.jpg",
    title: "I'm a 빛",
    duration: 168,
    artist_id: "756531",
    artist_name: "화사 (Hwa Sa)",
  },
  {
    song_id: 30992038,
    music:
      "https://api1.indj.club/api/v3/music/file?code=VbmXLqzWHAOiCIZgtITqnxlXsbGVBs8+M7belu1eed8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10153893.jpg",
    title: "바나나 알러지 원숭이",
    duration: 224,
    artist_id: "2112888",
    artist_name: "오마이걸 반하나",
  },
  {
    song_id: 31895208,
    music:
      "https://api1.indj.club/api/v3/music/file?code=69oV3EBAsNuNRb2p0sn+qF4lXCPPVql+Rzz2rq1p8xc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10302011.jpg",
    title: "열대야 (Fever)",
    duration: 214,
    artist_id: "828478",
    artist_name: "여자친구 (GFRIEND)",
  },
  {
    song_id: 32636587,
    music:
      "https://api1.indj.club/api/v3/music/file?code=BILmdXVPCZ0WC0R1e4JP5oYif2Px/i7/r4vp1/EV6Gc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10437780.jpg",
    title: "안녕과 안녕으로",
    duration: 234,
    artist_id: "718655",
    artist_name: "이예준",
  },
  {
    song_id: 5748401,
    music:
      "https://api1.indj.club/api/v3/music/file?code=4ngkB4AFQk8GBFz++QmG6OhsTXwy1SHLQTVzT51hnTo=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2325320.jpg",
    title: "아침부터 아침까지 (ah-ah)",
    duration: 200,
    artist_id: "483581",
    artist_name: "틴탑",
  },
  {
    song_id: 32108211,
    music:
      "https://api1.indj.club/api/v3/music/file?code=BILmdXVPCZ0WC0R1e4JP5vS5EnPhrGEIfvKOV71rlc4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10340681.jpg",
    title: "Like Strangers Do",
    duration: 161,
    artist_id: "2189633",
    artist_name: "AJ Mitchell",
  },
  {
    song_id: 5748406,
    music:
      "https://api1.indj.club/api/v3/music/file?code=4ngkB4AFQk8GBFz++QmG6MKFF1ZZ7FeI0G4uvgK/lcg=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2325321.jpg",
    title: "심쿵해 (Heart Attack)",
    duration: 197,
    artist_id: "686920",
    artist_name: "AOA",
  },
  {
    song_id: 5375679,
    music:
      "https://api1.indj.club/api/v3/music/file?code=IJcPrwWJbylv8W+rk0a9qKHTpk2LSifDcOqwPEQYYyE=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2281181.jpg",
    title: "미친거 아니야?",
    duration: 239,
    artist_id: "259822",
    artist_name: "2PM",
  },
  {
    song_id: 35686079,
    music:
      "https://api1.indj.club/api/v3/music/file?code=XRijHErTghZsPpyPhXPWxsSFynxOBO8XTbHnaqPfUQM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11067688.jpg",
    title: "불이나",
    duration: 214,
    artist_id: "630454",
    artist_name: "EXID",
  },
  {
    song_id: 8171202,
    music:
      "https://api1.indj.club/api/v3/music/file?code=OsxAfWHpfMZZvj1BQF8hWEdtvSDb9sf3c97USidXl7g=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2683309.jpg",
    title: "Dream Girls",
    duration: 218,
    artist_id: "960251",
    artist_name: "아이오아이 (I.O.I)",
  },
  {
    song_id: 34494149,
    music:
      "https://api1.indj.club/api/v3/music/file?code=mmj+x+rYMuImwYnb4QD3dvEaXkxx28kCzy3enks5unM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10830791.jpg",
    title: "Step Back",
    duration: 229,
    artist_id: "3063272",
    artist_name: "GOT the beat",
  },
  {
    song_id: 4171462,
    music:
      "https://api1.indj.club/api/v3/music/file?code=O7XWO9qcX8/wRuNjkaNhZ0kXdXc3wYDEBxcTo5IQF/g=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2192532.jpg",
    title: "U & I",
    duration: 195,
    artist_id: "629831",
    artist_name: "에일리(AILEE)",
  },
  {
    song_id: 35729104,
    music:
      "https://api1.indj.club/api/v3/music/file?code=XRijHErTghZsPpyPhXPWxv9FDeKJsCI/pENVwwjm4IE=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11078496.jpg",
    title: "ANTIFRAGILE",
    duration: 184,
    artist_id: "3092950",
    artist_name: "LE SSERAFIM (르세라핌)",
  },
  {
    song_id: 35309269,
    music:
      "https://api1.indj.club/api/v3/music/file?code=XRijHErTghZsPpyPhXPWxpAntUmObIw3DS/YPTHO4x0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10985927.jpg",
    title: "Up!",
    duration: 193,
    artist_id: "3058246",
    artist_name: "Kep1er (케플러)",
  },
  {
    song_id: 4818649,
    music:
      "https://api1.indj.club/api/v3/music/file?code=4tmj33Pyx41fLFn+Agv3zznvDyFrpUd52CO3/RUOjeQ=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2275068.jpg",
    title: "맘마미아",
    duration: 215,
    artist_id: "222128",
    artist_name: "카라",
  },
  {
    song_id: 35434206,
    music:
      "https://api1.indj.club/api/v3/music/file?code=XRijHErTghZsPpyPhXPWxuw3l2j8UR79K3UDI3dGiw0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11008450.jpg",
    title: "BEAUTIFUL MONSTER",
    duration: 181,
    artist_id: "2899290",
    artist_name: "STAYC(스테이씨)",
  },
  {
    song_id: 31381221,
    music:
      "https://api1.indj.club/api/v3/music/file?code=69oV3EBAsNuNRb2p0sn+qIHAjv4EtntRbpyCSDuYazo=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10216042.jpg",
    title: "I’ll Still Have Me",
    duration: 219,
    artist_id: "1816560",
    artist_name: "Cyn",
  },
  {
    song_id: 4148967,
    music:
      "https://api1.indj.club/api/v3/music/file?code=O7XWO9qcX8/wRuNjkaNhZ6kri7U2tG/tNkcA6EZ86yY=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2189686.jpg",
    title: "빠빠빠",
    duration: 181,
    artist_id: "685904",
    artist_name: "크레용팝",
  },
  {
    song_id: 31090412,
    music:
      "https://api1.indj.club/api/v3/music/file?code=69oV3EBAsNuNRb2p0sn+qDATouazrRCpDj1ZAJS9Ets=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10169551.jpg",
    title: "SELFISH (Feat. 슬기 Of Red Velvet)",
    duration: 193,
    artist_id: "756529",
    artist_name: "문별 (마마무)",
  },
  {
    song_id: 4042480,
    music:
      "https://api1.indj.club/api/v3/music/file?code=Qd1n9y+GN812gYZqFDKT81C+w8xXHOYq4H2hmmDVgoM=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2176269.jpg",
    title: "긴 생머리 그녀 (Miss Right)",
    duration: 198,
    artist_id: "483581",
    artist_name: "틴탑",
  },
  {
    song_id: 32636656,
    music:
      "https://api1.indj.club/api/v3/music/file?code=7Iid17dXab/uXsy3tXsUoCz87btejPyPcGitk2vwpb0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10437786.jpg",
    title: "MORE & MORE",
    duration: 200,
    artist_id: "905701",
    artist_name: "TWICE (트와이스)",
  },
  {
    song_id: 34041584,
    music:
      "https://api1.indj.club/api/v3/music/file?code=5Ht4kqMmFcaiLfX7kzfVHsyFuip2wn63Ig6PD6b/4DM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10731792.jpg",
    title: "Savage",
    duration: 239,
    artist_id: "2899555",
    artist_name: "aespa",
  },
  {
    song_id: 3837683,
    music:
      "https://api1.indj.club/api/v3/music/file?code=tOXneGZSj0AaFbBLWTppeKjm8X+rNH6tnKvsrYR2pDY=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2131509.jpg",
    title: "Loving U (러빙유)",
    duration: 218,
    artist_id: "473181",
    artist_name: "씨스타",
  },
  {
    song_id: 34041586,
    music:
      "https://api1.indj.club/api/v3/music/file?code=5Ht4kqMmFcaiLfX7kzfVHktsUFrDrkxYjetKwvv3XPk=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10731792.jpg",
    title: "YEPPI YEPPI",
    duration: 214,
    artist_id: "2899555",
    artist_name: "aespa",
  },
  {
    song_id: 34754292,
    music:
      "https://api1.indj.club/api/v3/music/file?code=5Ht4kqMmFcaiLfX7kzfVHtjrS3k16c1JNK5hMT0q7Tc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10890384.jpg",
    title: "TOMBOY",
    duration: 175,
    artist_id: "2137482",
    artist_name: "(G)I-dle ((여자)아이들)",
  },
  {
    song_id: 32190201,
    music:
      "https://api1.indj.club/api/v3/music/file?code=7Iid17dXab/uXsy3tXsUoF+b//5eyGDE/uRhP/WE6NU=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10337527.jpg",
    title: "Falling",
    duration: 240,
    artist_id: "1628764",
    artist_name: "Harry Styles",
  },
  {
    song_id: 31067899,
    music:
      "https://api1.indj.club/api/v3/music/file?code=x2wUGHopem9WcmbEAvuVO3ysPQYuSHyR01P4iadQ/rE=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10165685.jpg",
    title: "내꺼야 (PICK ME)",
    duration: 279,
    artist_id: "2139084",
    artist_name: "PRODUCE 48",
  },
  {
    song_id: 5584641,
    music:
      "https://api1.indj.club/api/v3/music/file?code=2IDv0bgFaZnfuLhCzNXhymmJ4LRr3q8rvorABCGCXGY=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2301463.jpg",
    title: "미쳐",
    duration: 192,
    artist_id: "417985",
    artist_name: "4minute",
  },
  {
    song_id: 31635202,
    music:
      "https://api1.indj.club/api/v3/music/file?code=x2wUGHopem9WcmbEAvuVO40xBEXaxSSBgGcs+5/cQks=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10255272.jpg",
    title: "Senorita",
    duration: 198,
    artist_id: "2137482",
    artist_name: "(G)I-dle ((여자)아이들)",
  },
  {
    song_id: 31969026,
    music:
      "https://api1.indj.club/api/v3/music/file?code=x2wUGHopem9WcmbEAvuVOzsGkhd7sa6Z8NORyItLwZk=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10314714.jpg",
    title: "HIT",
    duration: 204,
    artist_id: "861436",
    artist_name: "세븐틴",
  },
  {
    song_id: 8068879,
    music:
      "https://api1.indj.club/api/v3/music/file?code=S/e6awD9PJ938B/F87SYg2j9N/Z7E/GyrF66EX1ItqY=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2669407.jpg",
    title: "1cm의 자존심",
    duration: 184,
    artist_id: "750053",
    artist_name: "마마무 (Mamamoo)",
  },
  {
    song_id: 31608591,
    music:
      "https://api1.indj.club/api/v3/music/file?code=x2wUGHopem9WcmbEAvuVO4dWYn6Jx6GqoPi/pYeyIDc=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10250805.jpg",
    title: "PIRI",
    duration: 207,
    artist_id: "1284664",
    artist_name: "드림캐쳐",
  },
  {
    song_id: 35985167,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ONEQzkRQ94cgaDiJQk7ssIRh5+UYLHkMDZDJx4t+cVA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11127145.jpg",
    title: "OMG",
    duration: 213,
    artist_id: "3114174",
    artist_name: "NewJeans",
  },
  {
    song_id: 35727123,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ONEQzkRQ94cgaDiJQk7ssFndmaSts+zZZL+B2MFbriY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11078016.jpg",
    title: "맛있는 거 옆에",
    duration: 169,
    artist_id: "688432,672625",
    artist_name: "로꼬,GRAY (그레이)",
  },
  {
    song_id: 32358164,
    music:
      "https://api1.indj.club/api/v3/music/file?code=7Iid17dXab/uXsy3tXsUoKCS8DEf62gnVfLzbgMrZOk=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10384712.jpg",
    title: "So What",
    duration: 198,
    artist_id: "1229429",
    artist_name: "이달의 소녀",
  },
  {
    song_id: 5592860,
    music:
      "https://api1.indj.club/api/v3/music/file?code=2IDv0bgFaZnfuLhCzNXhyu4lz426yJZ0gXatCxhLv7Y=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2303942.jpg",
    title: "I Just Wanna (Feat. 에릭남)",
    duration: 193,
    artist_id: "668851",
    artist_name: "Amber Liu (엠버)",
  },
  {
    song_id: 30992157,
    music:
      "https://api1.indj.club/api/v3/music/file?code=AXBoKZpJt25hG3tV4OHhK/rJ5HxspNMgxp4gxKzHIoM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10153912.jpg",
    title: "빛나리",
    duration: 199,
    artist_id: "1201990",
    artist_name: "펜타곤",
  },
  {
    song_id: 31782686,
    music:
      "https://api1.indj.club/api/v3/music/file?code=x2wUGHopem9WcmbEAvuVO425rozWcxUfLG65usgcmU4=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10282459.jpg",
    title: "다섯 번째 계절 (SSFWL)",
    duration: 241,
    artist_id: "857994",
    artist_name: "오마이걸 (OH MY GIRL)",
  },
  {
    song_id: 31399721,
    music:
      "https://api1.indj.club/api/v3/music/file?code=x2wUGHopem9WcmbEAvuVO/Ies2iXus6buWKhrZ4deyA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10218750.jpg",
    title: "Tempo",
    duration: 225,
    artist_id: "724619",
    artist_name: "EXO",
  },
  {
    song_id: 9621298,
    music:
      "https://api1.indj.club/api/v3/music/file?code=gU1viimZWOFBEL1l+zdx/fFcIUN/7D8VgiskH4cqJwg=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2707281.jpg",
    title: "Daybreak (Minhyun&JR)",
    duration: 221,
    artist_id: "640891",
    artist_name: "뉴이스트",
  },
  {
    song_id: 31297335,
    music:
      "https://api1.indj.club/api/v3/music/file?code=x2wUGHopem9WcmbEAvuVO3pgNCMv9l53XRn4pDXeHLI=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10202711.jpg",
    title: "불꽃놀이 (Remember Me)",
    duration: 195,
    artist_id: "857994",
    artist_name: "오마이걸 (OH MY GIRL)",
  },
  {
    song_id: 30975805,
    music:
      "https://api1.indj.club/api/v3/music/file?code=AXBoKZpJt25hG3tV4OHhK45grfElDSz0eiY/OCbcBz0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10151409.jpg",
    title: "폭우",
    duration: 231,
    artist_id: "791216",
    artist_name: "몬스타엑스",
  },
  {
    song_id: 3440448,
    music:
      "https://api1.indj.club/api/v3/music/file?code=5Ht4kqMmFcaiLfX7kzfVHlR4vBBm5kXR3rcCuiKkOio=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/1306051.jpg",
    title: "Hot Summer",
    duration: 224,
    artist_id: "428501",
    artist_name: "f(x)",
  },
  {
    song_id: 33507137,
    music:
      "https://api1.indj.club/api/v3/music/file?code=SMhCDmmmrJFchfBOFtwZjY+hu0IU0M2vSl3/TFZ7x4A=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10612483.jpg",
    title: "Butter",
    duration: 165,
    artist_id: "672375",
    artist_name: "BTS",
  },
  {
    song_id: 32104269,
    music:
      "https://api1.indj.club/api/v3/music/file?code=7Iid17dXab/uXsy3tXsUoATe5MHoAEfey/p4Dz8r6sY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10340006.jpg",
    title:
      "If the World Was Ending (feat. Julia Michaels) (Feat. Julia Michaels)",
    duration: 209,
    artist_id: "2091191",
    artist_name: "JP Saxe",
  },
  {
    song_id: 32511830,
    music:
      "https://api1.indj.club/api/v3/music/file?code=7Iid17dXab/uXsy3tXsUoDth595IiVnLHl0nb2ObHhs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10413088.jpg",
    title: "Oh my god",
    duration: 196,
    artist_id: "2137482",
    artist_name: "(G)I-dle ((여자)아이들)",
  },
  {
    song_id: 30990167,
    music:
      "https://api1.indj.club/api/v3/music/file?code=AXBoKZpJt25hG3tV4OHhKxWUwUANnwRdEJS8h52IFOs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10153623.jpg",
    title: "내일해",
    duration: 191,
    artist_id: "630454",
    artist_name: "EXID",
  },
  {
    song_id: 32651098,
    music:
      "https://api1.indj.club/api/v3/music/file?code=7Iid17dXab/uXsy3tXsUoJ40Un4mm0e5GdrmFolIiK0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10440381.jpg",
    title: "사랑은 지날수록 더욱 선명하게 남아",
    duration: 231,
    artist_id: "979724",
    artist_name: "전상근",
  },
  {
    song_id: 31872859,
    music:
      "https://api1.indj.club/api/v3/music/file?code=x2wUGHopem9WcmbEAvuVO8kXoj9JdrWzuKnGBpun+o8=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10297980.jpg",
    title: "짐살라빔 (Zimzalabim)",
    duration: 191,
    artist_id: "780066",
    artist_name: "Red Velvet (레드벨벳)",
  },
  {
    song_id: 3600223,
    music:
      "https://api1.indj.club/api/v3/music/file?code=6kNAFFYliFVDoDsCkb+wKpWOhDSnAKiArSR+KmqHgf0=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2030418.jpg",
    title: "Be My Baby",
    duration: 212,
    artist_id: "217764",
    artist_name: "원더걸스",
  },
  {
    song_id: 3452769,
    music:
      "https://api1.indj.club/api/v3/music/file?code=5Ht4kqMmFcaiLfX7kzfVHnURdq05NHvYN2Pp4daxpRc=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/1315551.jpg",
    title: "내가 제일 잘 나가",
    duration: 211,
    artist_id: "406712",
    artist_name: "2NE1",
  },
  {
    song_id: 34377570,
    music:
      "https://api1.indj.club/api/v3/music/file?code=5Ht4kqMmFcaiLfX7kzfVHpZLhSTHLdDHcIzdRWkAS0U=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10805063.jpg",
    title: "탕!♡",
    duration: 179,
    artist_id: "742773",
    artist_name: "MINO (송민호)",
  },
  {
    song_id: 4818802,
    music:
      "https://api1.indj.club/api/v3/music/file?code=udycOBHQWEQBIpmMfKH8F7QUzH39o+0Z7Y5jjecbwGI=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2275087.jpg",
    title: "괴도 (Danger)",
    duration: 191,
    artist_id: "629371",
    artist_name: "태민 (TAEMIN)",
  },
  {
    song_id: 4491123,
    music:
      "https://api1.indj.club/api/v3/music/file?code=I+ftKCcoEOCRnAHgbKVQd20biRRHC0G9/ukW7bKkiCU=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2238344.jpg",
    title: "Delicious",
    duration: 206,
    artist_id: "760193",
    artist_name: "투하트 (우현, 키)",
  },
  {
    song_id: 33214327,
    music:
      "https://api1.indj.club/api/v3/music/file?code=SMhCDmmmrJFchfBOFtwZjaxQb2EvKRWpZN6PT0T2qrQ=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10549175.jpg",
    title: "Rosario (Feat. CL, ZICO)",
    duration: 230,
    artist_id: "108356",
    artist_name: "에픽하이 (EPIK HIGH)",
  },
  {
    song_id: 35542908,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ONEQzkRQ94cgaDiJQk7ssBZVTHdPS1ELLWaw7c7x/VE=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11033394.jpg",
    title: "Pink Venom",
    duration: 166,
    artist_id: "995169",
    artist_name: "BLACKPINK",
  },
  {
    song_id: 35510146,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ONEQzkRQ94cgaDiJQk7ssFSfauwamKjtryh25Hxl82w=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11024679.jpg",
    title: "WHISPER",
    duration: 192,
    artist_id: "1816126",
    artist_name: "더보이즈 (THE BOYZ)",
  },
  {
    song_id: 35223429,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ONEQzkRQ94cgaDiJQk7ssAduxtcMSayj1NwnTt5a3aw=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10922231.jpg",
    title: "HOT",
    duration: 197,
    artist_id: "861436",
    artist_name: "세븐틴",
  },
  {
    song_id: 32864149,
    music:
      "https://api1.indj.club/api/v3/music/file?code=7Iid17dXab/uXsy3tXsUoE+nTVtKJQvM/E5OfWp1+XY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10477445.jpg",
    title: "SAY MY NAME",
    duration: 206,
    artist_id: "573812",
    artist_name: "효린",
  },
  {
    song_id: 608151,
    music:
      "https://api1.indj.club/api/v3/music/file?code=xdI+5TMF2+COY0AYQs83rnVLyfHFItLkGtEhFWh3kyw=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/40234.jpg",
    title: "아틀란티스 소녀 (Atlantis Princess)",
    duration: 224,
    artist_id: "2165",
    artist_name: "보아 (BoA)",
  },
  {
    song_id: 33632153,
    music:
      "https://api1.indj.club/api/v3/music/file?code=SMhCDmmmrJFchfBOFtwZjcndAs5NfW+jpLM2ywdAzEY=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10639807.jpg",
    title: "비 오는 날 듣기 좋은 노래 (Feat. Colde)",
    duration: 0,
    artist_id: "108356",
    artist_name: "에픽하이 (EPIK HIGH)",
  },
  {
    song_id: 7853979,
    music:
      "https://api1.indj.club/api/v3/music/file?code=zraP3djAdNk6ChiB9Tn6BpOm5/UD24qYMyzlfkfyNPg=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2640114.jpg",
    title: "왠지 (Somehow)",
    duration: 207,
    artist_id: "890286",
    artist_name: "DIA (다이아)",
  },
  {
    song_id: 31969182,
    music:
      "https://api1.indj.club/api/v3/music/file?code=x2wUGHopem9WcmbEAvuVO5cn8Ue36KanvhgzKsnxs+k=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10314743.jpg",
    title: "BUNGEE (Fall in Love)",
    duration: 178,
    artist_id: "857994",
    artist_name: "오마이걸 (OH MY GIRL)",
  },
  {
    song_id: 33437611,
    music:
      "https://api1.indj.club/api/v3/music/file?code=SMhCDmmmrJFchfBOFtwZjQa1UfnnTzmg2LqhW2xMBDE=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10598357.jpg",
    title: "Drunk-Dazed",
    duration: 193,
    artist_id: "2899079",
    artist_name: "ENHYPEN",
  },
  {
    song_id: 31238062,
    music:
      "https://api1.indj.club/api/v3/music/file?code=x2wUGHopem9WcmbEAvuVO1ThZL+gcDhdJosXDT16WVM=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10193008.jpg",
    title: "우우 (WooWoo)",
    duration: 201,
    artist_id: "890286",
    artist_name: "DIA (다이아)",
  },
  {
    song_id: 4771771,
    music:
      "https://api1.indj.club/api/v3/music/file?code=g8i+2EhHUFEhAgjbz1PEKne5FQnxv/kBa/M5AHwfcPY=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2269895.jpg",
    title: "빨개요",
    duration: 200,
    artist_id: "449401",
    artist_name: "현아",
  },
  {
    song_id: 31608765,
    music:
      "https://api1.indj.club/api/v3/music/file?code=x2wUGHopem9WcmbEAvuVO7waEbA0c5ZSgVuwXpHWinA=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10250874.jpg",
    title: "멍청이(twit)",
    duration: 191,
    artist_id: "756531",
    artist_name: "화사 (Hwa Sa)",
  },
  {
    song_id: 36726727,
    music:
      "https://api1.indj.club/api/v3/music/file?code=6kNAFFYliFVDoDsCkb+wKpNtr3xfRjK9mzDI4ukX6Ko=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11312119.jpg",
    title: "Baggy Jeans",
    duration: 212,
    artist_id: "960278",
    artist_name: "NCT U",
  },
  {
    song_id: 36411342,
    music:
      "https://api1.indj.club/api/v3/music/file?code=6kNAFFYliFVDoDsCkb+wKuSd6pFYPRjI2MDyx06PsVs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11234678.jpg",
    title: "UNFORGIVEN (feat. Nile Rodgers)",
    duration: 182,
    artist_id: "3092950",
    artist_name: "LE SSERAFIM (르세라핌)",
  },
  {
    song_id: 5820369,
    music:
      "https://api1.indj.club/api/v3/music/file?code=LNKiNzFv/T4+eQwhwuvMsSySgSRtv+mxEu3QcngxWgU=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2335204.jpg",
    title: "You Think",
    duration: 189,
    artist_id: "228069",
    artist_name: "GIRLS' GENERATION (소녀시대)",
  },
  {
    song_id: 33628125,
    music:
      "https://api1.indj.club/api/v3/music/file?code=SMhCDmmmrJFchfBOFtwZjeHVvQsTyVZChRMalyxkLZ0=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10638810.jpg",
    title: "Hello Future",
    duration: 221,
    artist_id: "1066419",
    artist_name: "NCT DREAM",
  },
  {
    song_id: 34254823,
    music:
      "https://api1.indj.club/api/v3/music/file?code=5Ht4kqMmFcaiLfX7kzfVHsWlkfI0/JuDTaze71dLAzo=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10774753.jpg",
    title: "SCIENTIST",
    duration: 195,
    artist_id: "905701",
    artist_name: "TWICE (트와이스)",
  },
  {
    song_id: 8304617,
    music:
      "https://api1.indj.club/api/v3/music/file?code=jzMKpBaqA4tuUg36RRmE7iVnDJD3TALg4+YeqV7Ypu8=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2703172.jpg",
    title: "Whatta Man (Good man)",
    duration: 194,
    artist_id: "960251",
    artist_name: "아이오아이 (I.O.I)",
  },
  {
    song_id: 33353705,
    music:
      "https://api1.indj.club/api/v3/music/file?code=SMhCDmmmrJFchfBOFtwZjVLCCDGLXvX/720IIUGl5Cs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10578808.jpg",
    title: "어떤X (What Type of X)",
    duration: 198,
    artist_id: "176393",
    artist_name: "Jessi (제시)",
  },
  {
    song_id: 4454382,
    music:
      "https://api1.indj.club/api/v3/music/file?code=I+ftKCcoEOCRnAHgbKVQdwfra2H8srsReAoHn3XC1jU=",
    thumbnail: "https://api1.indj.club/api/v3/channel/image/COVERS/2233456.jpg",
    title: "보름달 (Feat. Lena)",
    duration: 202,
    artist_id: "22938",
    artist_name: "선미",
  },
  {
    song_id: 35205102,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ONEQzkRQ94cgaDiJQk7ssFkXBUyHuCSjyImCBaZ/QEs=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10965502.jpg",
    title: "ALIVE",
    duration: 187,
    artist_id: "2941794",
    artist_name: "LIGHTSUM",
  },
  {
    song_id: 35868657,
    music:
      "https://api1.indj.club/api/v3/music/file?code=ONEQzkRQ94cgaDiJQk7ssPjo4/LzLXNKDG/MkLKBHZE=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/11110911.jpg",
    title: "Birthday",
    duration: 216,
    artist_id: "780066",
    artist_name: "Red Velvet (레드벨벳)",
  },
  {
    song_id: 33353715,
    music:
      "https://api1.indj.club/api/v3/music/file?code=SMhCDmmmrJFchfBOFtwZjQBMTJWO753MsSGL7wxD/3M=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10578815.jpg",
    title: "After School",
    duration: 205,
    artist_id: "2399776",
    artist_name: "Weeekly (위클리)",
  },
  {
    song_id: 33320959,
    music:
      "https://api1.indj.club/api/v3/music/file?code=SMhCDmmmrJFchfBOFtwZjZdHuqj2s4i6l9VtUMP8f0o=",
    thumbnail:
      "https://api1.indj.club/api/v3/channel/image/COVERS/10571325.jpg",
    title: "불놀이야 (I'm The one)",
    duration: 210,
    artist_id: "2398260",
    artist_name: "ATEEZ (에이티즈)",
  },
];

export default data;
